var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _path156, _path157, _path158, _path159, _path160, _path161, _path162, _path163, _path164, _path165, _path166, _path167, _path168, _path169, _path170, _path171, _path172, _path173, _path174, _path175, _path176, _path177, _path178, _path179, _path180, _path181, _path182, _path183, _path184, _path185, _path186, _path187, _path188, _path189, _path190, _path191, _path192, _path193, _path194, _path195, _path196, _path197, _path198, _path199, _path200, _path201, _path202, _path203, _path204, _path205, _path206, _path207, _path208, _path209, _path210, _path211, _path212, _path213, _path214, _path215, _path216, _path217, _path218, _path219, _path220, _path221, _path222, _path223, _path224, _path225, _path226, _path227, _path228, _path229, _path230, _path231, _path232, _path233, _path234, _path235, _path236, _path237, _path238, _path239, _path240, _path241, _path242, _path243, _path244, _path245, _path246, _path247, _path248, _path249, _path250, _path251, _path252, _path253, _path254, _path255, _path256, _path257, _path258, _path259, _path260, _path261, _path262, _path263, _path264, _path265, _path266, _path267, _path268, _path269, _path270, _path271, _path272, _path273, _path274, _path275, _path276, _path277, _path278, _path279, _path280, _path281, _path282, _path283, _path284, _path285, _path286, _path287, _path288, _path289, _path290, _path291, _path292, _path293, _path294, _path295, _path296, _path297, _path298, _path299, _path300, _path301, _path302, _path303, _path304, _path305, _path306, _path307, _path308, _path309, _path310, _path311, _path312, _path313, _path314, _path315, _path316, _path317, _path318, _path319, _path320, _path321, _path322, _path323, _path324, _path325, _path326, _path327, _path328, _path329, _path330, _path331, _path332, _path333, _path334, _path335, _path336, _path337, _path338, _path339, _path340, _path341, _path342, _path343, _path344, _path345, _path346, _path347, _path348, _path349, _path350, _path351, _path352, _path353, _path354, _path355, _path356, _path357, _path358, _path359, _path360, _path361, _path362, _path363, _path364, _path365, _path366, _path367, _path368, _path369, _path370, _path371, _path372, _path373, _path374, _path375, _path376, _path377, _path378, _path379, _path380, _path381, _path382, _path383, _path384, _path385, _path386, _path387, _path388, _path389, _path390, _path391, _path392, _path393, _path394, _path395, _path396, _path397, _path398, _path399, _path400, _path401, _path402, _path403, _path404, _path405, _path406, _path407, _path408, _path409, _path410, _path411, _path412, _path413, _path414, _path415, _path416, _path417, _path418, _path419, _path420, _path421, _path422, _path423, _path424, _path425, _path426, _path427, _path428, _path429, _path430, _path431, _path432, _path433, _path434, _path435, _path436, _path437, _path438, _path439, _path440, _path441, _path442, _path443, _path444, _path445, _path446, _path447, _path448, _path449, _path450, _path451, _path452, _path453, _path454, _path455, _path456, _path457, _path458, _path459, _path460, _path461, _path462, _path463, _path464, _path465, _path466, _path467, _path468, _path469, _path470, _path471, _path472, _path473, _path474, _path475, _path476, _path477, _path478, _path479, _path480, _path481, _path482, _path483, _path484, _path485, _path486, _path487, _path488, _path489, _path490, _path491, _path492, _path493, _path494, _path495, _path496, _path497, _path498, _path499, _path500, _path501, _path502, _path503, _path504, _path505, _path506, _path507, _path508, _path509, _path510, _path511, _path512, _path513, _path514, _path515, _path516, _path517, _path518, _path519, _path520, _path521, _path522, _path523, _path524, _path525, _path526, _path527, _path528, _path529, _path530, _path531, _path532, _path533, _path534, _path535, _path536, _path537, _path538, _path539, _path540, _path541, _path542, _path543, _path544, _path545, _path546, _path547, _path548, _path549, _path550, _path551, _path552, _path553, _path554, _path555, _path556, _path557, _path558, _path559, _path560, _path561, _path562, _path563, _path564, _path565, _path566, _path567, _path568, _path569, _path570, _path571, _path572, _path573, _path574, _path575, _path576, _path577, _path578, _path579, _path580, _path581, _path582, _path583, _path584, _path585, _path586, _path587, _path588, _g, _path589, _path590, _path591, _g2, _path592, _path593, _path594, _path595, _path596, _path597, _path598, _path599, _path600, _path601, _path602, _path603, _path604, _path605, _path606, _path607, _path608, _path609, _path610, _path611, _path612, _path613, _path614, _path615, _path616, _path617, _path618, _path619, _path620, _path621, _path622, _path623, _path624, _path625, _path626, _path627, _path628, _path629, _path630, _path631, _path632, _path633, _path634, _path635, _path636, _path637, _path638, _path639, _path640, _path641, _path642, _path643, _path644, _path645, _path646, _path647, _path648, _path649, _path650, _path651, _path652, _path653, _path654, _path655, _path656, _path657, _path658, _path659, _path660, _path661, _path662, _path663, _path664, _path665, _path666, _path667, _path668, _path669, _path670, _path671, _path672, _path673, _path674, _path675, _path676, _path677, _path678, _path679, _path680, _path681, _path682, _path683, _path684, _path685, _path686, _path687, _path688, _path689, _path690, _path691, _path692, _path693, _path694, _path695, _path696, _path697, _path698, _path699, _path700, _path701, _path702, _path703, _path704, _path705, _path706, _path707, _path708, _path709, _path710, _path711, _path712, _path713, _path714, _path715, _path716, _path717, _path718, _g3, _path719, _path720, _path721, _g4, _path722, _path723, _path724, _path725, _path726, _path727, _path728, _path729, _path730, _path731, _path732, _path733, _path734, _path735, _path736, _path737, _path738, _path739, _path740, _path741, _path742, _path743, _path744, _path745, _path746, _path747, _path748, _path749, _path750, _path751, _path752, _path753, _path754, _path755, _path756, _path757, _path758, _path759, _path760, _path761, _path762, _path763, _path764, _path765, _path766, _path767, _path768, _path769, _g5, _path770, _path771, _path772, _path773, _path774, _path775, _path776, _path777, _path778, _path779, _path780, _path781, _path782, _path783, _path784, _path785, _path786, _path787, _path788, _path789, _path790, _path791, _path792, _path793, _path794, _path795, _path796, _path797, _path798, _path799, _path800, _path801;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSlider2Img(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 418,
    height: 311,
    viewBox: "0 0 418 311",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M417.991 273.304H0.663818V273.513H417.991V273.304Z",
    fill: "#EBEBEB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M376.176 286.739H348.531V286.948H376.176V286.739Z",
    fill: "#EBEBEB"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M277.118 289.004H269.863V289.213H277.118V289.004Z",
    fill: "#EBEBEB"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M347.695 278.988H331.677V279.197H347.695V278.988Z",
    fill: "#EBEBEB"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M80.5002 280.391H44.449V280.6H80.5002V280.391Z",
    fill: "#EBEBEB"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M93.218 280.391H87.9321V280.6H93.218V280.391Z",
    fill: "#EBEBEB"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M188.584 283.916H110.397V284.124H188.584V283.916Z",
    fill: "#EBEBEB"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M198.489 236.081H37.3177C34.691 236.081 32.5535 233.943 32.5535 231.316V4.76421C32.5535 2.13755 34.691 0 37.3177 0H198.489C201.115 0 203.252 2.13755 203.252 4.76421V231.316C203.252 233.943 201.115 236.081 198.489 236.081ZM37.3177 0.209498C34.8054 0.209498 32.7621 2.25273 32.7621 4.76505V231.317C32.7621 233.829 34.8054 235.873 37.3177 235.873H198.489C201 235.873 203.043 233.829 203.043 231.317V4.76421C203.043 2.25273 201 0.208664 198.489 0.208664L37.3177 0.209498Z",
    fill: "#EBEBEB"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M379.021 236.081H217.851C215.224 236.081 213.088 233.943 213.088 231.316V4.76421C213.088 2.13755 215.225 0 217.851 0H379.021C381.649 0 383.785 2.13755 383.785 4.76421V231.316C383.786 233.943 381.649 236.081 379.021 236.081ZM217.851 0.209498C215.34 0.209498 213.296 2.25273 213.296 4.76505V231.317C213.296 233.829 215.34 235.873 217.851 235.873H379.021C381.534 235.873 383.577 233.829 383.577 231.317V4.76421C383.577 2.25273 381.534 0.208664 379.021 0.208664L217.851 0.209498Z",
    fill: "#EBEBEB"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M347.322 54.887H205.834V213.401H347.322V54.887Z",
    fill: "#EBEBEB"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M344.545 57.4436H205.834V210.594H344.545V57.4436Z",
    fill: "#FAFAFA"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M339.42 138.732V127.972H336.346V120.799H332.247V110.038H331.222V120.799H327.122V127.972H324.048V138.732H318.412V141.807H315.85V153.592H315.338V136.683H313.8V147.443H312.263V121.823H311.238V132.584H307.139V128.997H305.602V114.137H302.528V99.2781H301.503V101.327H280.494V95.1782H276.908V71.6084H275.37V95.1782H270.246V101.327H268.197V132.072H257.436V122.848H261.023V121.311H257.436V118.749H247.188V95.1782H244.626V91.5917H232.329V95.1782H230.791V127.972H225.155V142.832H222.081V131.047H219.519V127.972H213.882V117.211H210.807V110.038H207.221V99.2781H205.834V210.594H344.544V138.732H339.42Z",
    fill: "#F0F0F0"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M289.792 102.934H288.34V104.385H289.792V102.934Z",
    fill: "#FAFAFA"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M289.792 105.368H288.34V106.819H289.792V105.368Z",
    fill: "#FAFAFA"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M289.792 115.103H288.34V116.555H289.792V115.103Z",
    fill: "#FAFAFA"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M289.792 117.537H288.34V118.988H289.792V117.537Z",
    fill: "#FAFAFA"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M289.792 119.971H288.34V121.423H289.792V119.971Z",
    fill: "#FAFAFA"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M289.792 127.273H288.34V128.725H289.792V127.273Z",
    fill: "#FAFAFA"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M289.792 129.707H288.34V131.158H289.792V129.707Z",
    fill: "#FAFAFA"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M287.485 112.669H286.034V114.121H287.485V112.669Z",
    fill: "#FAFAFA"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M287.485 115.103H286.034V116.555H287.485V115.103Z",
    fill: "#FAFAFA"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M287.485 117.537H286.034V118.988H287.485V117.537Z",
    fill: "#FAFAFA"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M287.485 119.971H286.034V121.423H287.485V119.971Z",
    fill: "#FAFAFA"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M287.485 122.405H286.034V123.856H287.485V122.405Z",
    fill: "#FAFAFA"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M287.485 127.273H286.034V128.725H287.485V127.273Z",
    fill: "#FAFAFA"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M287.485 129.707H286.034V131.158H287.485V129.707Z",
    fill: "#FAFAFA"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M285.18 102.934H283.729V104.385H285.18V102.934Z",
    fill: "#FAFAFA"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M285.18 105.368H283.729V106.819H285.18V105.368Z",
    fill: "#FAFAFA"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M285.18 107.801H283.729V109.253H285.18V107.801Z",
    fill: "#FAFAFA"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M285.18 110.235H283.729V111.687H285.18V110.235Z",
    fill: "#FAFAFA"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M285.18 112.669H283.729V114.121H285.18V112.669Z",
    fill: "#FAFAFA"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M285.18 115.103H283.729V116.555H285.18V115.103Z",
    fill: "#FAFAFA"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M285.18 117.537H283.729V118.988H285.18V117.537Z",
    fill: "#FAFAFA"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M285.18 119.971H283.729V121.423H285.18V119.971Z",
    fill: "#FAFAFA"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M285.18 122.405H283.729V123.856H285.18V122.405Z",
    fill: "#FAFAFA"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M285.18 124.839H283.729V126.291H285.18V124.839Z",
    fill: "#FAFAFA"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M285.18 129.707H283.729V131.158H285.18V129.707Z",
    fill: "#FAFAFA"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M282.874 102.934H281.422V104.385H282.874V102.934Z",
    fill: "#FAFAFA"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M282.874 105.368H281.422V106.819H282.874V105.368Z",
    fill: "#FAFAFA"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M282.874 107.801H281.422V109.253H282.874V107.801Z",
    fill: "#FAFAFA"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M282.874 110.235H281.422V111.687H282.874V110.235Z",
    fill: "#FAFAFA"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M282.874 112.669H281.422V114.121H282.874V112.669Z",
    fill: "#FAFAFA"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M282.874 115.103H281.422V116.555H282.874V115.103Z",
    fill: "#FAFAFA"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M282.874 117.537H281.422V118.988H282.874V117.537Z",
    fill: "#FAFAFA"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M282.874 139.442H281.422V140.895H282.874V139.442Z",
    fill: "#FAFAFA"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M280.568 102.934H279.117V104.385H280.568V102.934Z",
    fill: "#FAFAFA"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M280.568 105.368H279.117V106.819H280.568V105.368Z",
    fill: "#FAFAFA"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M280.568 107.801H279.117V109.253H280.568V107.801Z",
    fill: "#FAFAFA"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M280.568 110.235H279.117V111.687H280.568V110.235Z",
    fill: "#FAFAFA"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M280.568 112.669H279.117V114.121H280.568V112.669Z",
    fill: "#FAFAFA"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M280.568 115.103H279.117V116.555H280.568V115.103Z",
    fill: "#FAFAFA"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M280.568 117.537H279.117V118.988H280.568V117.537Z",
    fill: "#FAFAFA"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M280.568 119.971H279.117V121.423H280.568V119.971Z",
    fill: "#FAFAFA"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M280.568 134.575H279.117V136.027H280.568V134.575Z",
    fill: "#FAFAFA"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M280.568 137.009H279.117V138.46H280.568V137.009Z",
    fill: "#FAFAFA"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M280.568 139.442H279.117V140.895H280.568V139.442Z",
    fill: "#FAFAFA"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M280.568 141.876H279.117V143.329H280.568V141.876Z",
    fill: "#FAFAFA"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M280.568 151.612H279.117V153.063H280.568V151.612Z",
    fill: "#FAFAFA"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M278.262 102.934H276.811V104.385H278.262V102.934Z",
    fill: "#FAFAFA"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M278.262 105.368H276.811V106.819H278.262V105.368Z",
    fill: "#FAFAFA"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M278.262 107.801H276.811V109.253H278.262V107.801Z",
    fill: "#FAFAFA"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M278.262 110.235H276.811V111.687H278.262V110.235Z",
    fill: "#FAFAFA"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M278.262 112.669H276.811V114.121H278.262V112.669Z",
    fill: "#FAFAFA"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M278.262 115.103H276.811V116.555H278.262V115.103Z",
    fill: "#FAFAFA"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M278.262 117.537H276.811V118.988H278.262V117.537Z",
    fill: "#FAFAFA"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M278.262 119.971H276.811V121.423H278.262V119.971Z",
    fill: "#FAFAFA"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M278.262 122.405H276.811V123.856H278.262V122.405Z",
    fill: "#FAFAFA"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M278.262 124.839H276.811V126.291H278.262V124.839Z",
    fill: "#FAFAFA"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M278.262 132.141H276.811V133.593H278.262V132.141Z",
    fill: "#FAFAFA"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M278.262 134.575H276.811V136.027H278.262V134.575Z",
    fill: "#FAFAFA"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M278.262 137.009H276.811V138.46H278.262V137.009Z",
    fill: "#FAFAFA"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M278.262 139.442H276.811V140.895H278.262V139.442Z",
    fill: "#FAFAFA"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M278.262 141.876H276.811V143.329H278.262V141.876Z",
    fill: "#FAFAFA"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M278.262 151.612H276.811V153.063H278.262V151.612Z",
    fill: "#FAFAFA"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M275.956 102.934H274.505V104.385H275.956V102.934Z",
    fill: "#FAFAFA"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M275.956 105.368H274.505V106.819H275.956V105.368Z",
    fill: "#FAFAFA"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M275.956 107.801H274.505V109.253H275.956V107.801Z",
    fill: "#FAFAFA"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M275.956 110.235H274.505V111.687H275.956V110.235Z",
    fill: "#FAFAFA"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M275.956 112.669H274.505V114.121H275.956V112.669Z",
    fill: "#FAFAFA"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M275.956 115.103H274.505V116.555H275.956V115.103Z",
    fill: "#FAFAFA"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M275.956 117.537H274.505V118.988H275.956V117.537Z",
    fill: "#FAFAFA"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M275.956 119.971H274.505V121.423H275.956V119.971Z",
    fill: "#FAFAFA"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M275.956 122.405H274.505V123.856H275.956V122.405Z",
    fill: "#FAFAFA"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M275.956 124.839H274.505V126.291H275.956V124.839Z",
    fill: "#FAFAFA"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M275.956 127.273H274.505V128.725H275.956V127.273Z",
    fill: "#FAFAFA"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M275.956 129.707H274.505V131.158H275.956V129.707Z",
    fill: "#FAFAFA"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M275.956 132.141H274.505V133.593H275.956V132.141Z",
    fill: "#FAFAFA"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M275.956 134.575H274.505V136.027H275.956V134.575Z",
    fill: "#FAFAFA"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M275.956 137.009H274.505V138.46H275.956V137.009Z",
    fill: "#FAFAFA"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M275.956 139.442H274.505V140.895H275.956V139.442Z",
    fill: "#FAFAFA"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M275.956 141.876H274.505V143.329H275.956V141.876Z",
    fill: "#FAFAFA"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M275.956 144.31H274.505V145.762H275.956V144.31Z",
    fill: "#FAFAFA"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M273.651 102.934H272.199V104.385H273.651V102.934Z",
    fill: "#FAFAFA"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M273.651 105.368H272.199V106.819H273.651V105.368Z",
    fill: "#FAFAFA"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M273.651 107.801H272.199V109.253H273.651V107.801Z",
    fill: "#FAFAFA"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M273.651 110.235H272.199V111.687H273.651V110.235Z",
    fill: "#FAFAFA"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M273.651 112.669H272.199V114.121H273.651V112.669Z",
    fill: "#FAFAFA"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M273.651 115.103H272.199V116.555H273.651V115.103Z",
    fill: "#FAFAFA"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M273.651 117.537H272.199V118.988H273.651V117.537Z",
    fill: "#FAFAFA"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M273.651 119.971H272.199V121.423H273.651V119.971Z",
    fill: "#FAFAFA"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M273.651 122.405H272.199V123.856H273.651V122.405Z",
    fill: "#FAFAFA"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M273.651 124.839H272.199V126.291H273.651V124.839Z",
    fill: "#FAFAFA"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M273.651 132.141H272.199V133.593H273.651V132.141Z",
    fill: "#FAFAFA"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M273.651 134.575H272.199V136.027H273.651V134.575Z",
    fill: "#FAFAFA"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M273.651 137.009H272.199V138.46H273.651V137.009Z",
    fill: "#FAFAFA"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M273.651 139.442H272.199V140.895H273.651V139.442Z",
    fill: "#FAFAFA"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M271.345 102.934H269.893V104.385H271.345V102.934Z",
    fill: "#FAFAFA"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M271.345 105.368H269.893V106.819H271.345V105.368Z",
    fill: "#FAFAFA"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M271.345 107.801H269.893V109.253H271.345V107.801Z",
    fill: "#FAFAFA"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M271.345 110.235H269.893V111.687H271.345V110.235Z",
    fill: "#FAFAFA"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M271.345 112.669H269.893V114.121H271.345V112.669Z",
    fill: "#FAFAFA"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M271.345 115.103H269.893V116.555H271.345V115.103Z",
    fill: "#FAFAFA"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M271.345 117.537H269.893V118.988H271.345V117.537Z",
    fill: "#FAFAFA"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M271.345 119.971H269.893V121.423H271.345V119.971Z",
    fill: "#FAFAFA"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M271.345 122.405H269.893V123.856H271.345V122.405Z",
    fill: "#FAFAFA"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M271.345 124.839H269.893V126.291H271.345V124.839Z",
    fill: "#FAFAFA"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M271.345 132.141H269.893V133.593H271.345V132.141Z",
    fill: "#FAFAFA"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M271.345 134.575H269.893V136.027H271.345V134.575Z",
    fill: "#FAFAFA"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M271.345 137.009H269.893V138.46H271.345V137.009Z",
    fill: "#FAFAFA"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M245.384 96.6145H243.932V98.066H245.384V96.6145Z",
    fill: "#FAFAFA"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "M245.384 99.0483H243.932V100.5H245.384V99.0483Z",
    fill: "#FAFAFA"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "M245.384 101.482H243.932V102.934H245.384V101.482Z",
    fill: "#FAFAFA"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "M245.384 103.916H243.932V105.368H245.384V103.916Z",
    fill: "#FAFAFA"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "M245.384 106.35H243.932V107.802H245.384V106.35Z",
    fill: "#FAFAFA"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "M245.384 108.784H243.932V110.235H245.384V108.784Z",
    fill: "#FAFAFA"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    d: "M245.384 111.218H243.932V112.669H245.384V111.218Z",
    fill: "#FAFAFA"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    d: "M245.384 113.652H243.932V115.103H245.384V113.652Z",
    fill: "#FAFAFA"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    d: "M245.384 120.953H243.932V122.405H245.384V120.953Z",
    fill: "#FAFAFA"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    d: "M245.384 123.387H243.932V124.838H245.384V123.387Z",
    fill: "#FAFAFA"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    d: "M243.078 96.6145H241.626V98.066H243.078V96.6145Z",
    fill: "#FAFAFA"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    d: "M243.078 99.0483H241.626V100.5H243.078V99.0483Z",
    fill: "#FAFAFA"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    d: "M243.078 101.482H241.626V102.934H243.078V101.482Z",
    fill: "#FAFAFA"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    d: "M243.078 103.916H241.626V105.368H243.078V103.916Z",
    fill: "#FAFAFA"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    d: "M243.078 106.35H241.626V107.802H243.078V106.35Z",
    fill: "#FAFAFA"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    d: "M243.078 108.784H241.626V110.235H243.078V108.784Z",
    fill: "#FAFAFA"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    d: "M243.078 111.218H241.626V112.669H243.078V111.218Z",
    fill: "#FAFAFA"
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    d: "M243.078 113.652H241.626V115.103H243.078V113.652Z",
    fill: "#FAFAFA"
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    d: "M243.078 123.387H241.626V124.838H243.078V123.387Z",
    fill: "#FAFAFA"
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    d: "M240.772 96.6145H239.32V98.066H240.772V96.6145Z",
    fill: "#FAFAFA"
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    d: "M240.772 99.0483H239.32V100.5H240.772V99.0483Z",
    fill: "#FAFAFA"
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    d: "M240.772 101.482H239.32V102.934H240.772V101.482Z",
    fill: "#FAFAFA"
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    d: "M240.772 103.916H239.32V105.368H240.772V103.916Z",
    fill: "#FAFAFA"
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    d: "M240.772 106.35H239.32V107.802H240.772V106.35Z",
    fill: "#FAFAFA"
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    d: "M240.772 108.784H239.32V110.235H240.772V108.784Z",
    fill: "#FAFAFA"
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    d: "M240.772 111.218H239.32V112.669H240.772V111.218Z",
    fill: "#FAFAFA"
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    d: "M240.772 113.652H239.32V115.103H240.772V113.652Z",
    fill: "#FAFAFA"
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    d: "M238.467 96.6145H237.015V98.066H238.467V96.6145Z",
    fill: "#FAFAFA"
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    d: "M238.467 99.0483H237.015V100.5H238.467V99.0483Z",
    fill: "#FAFAFA"
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    d: "M238.467 101.482H237.015V102.934H238.467V101.482Z",
    fill: "#FAFAFA"
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    d: "M238.467 103.916H237.015V105.368H238.467V103.916Z",
    fill: "#FAFAFA"
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    d: "M238.467 106.35H237.015V107.802H238.467V106.35Z",
    fill: "#FAFAFA"
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    d: "M238.467 108.784H237.015V110.235H238.467V108.784Z",
    fill: "#FAFAFA"
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    d: "M238.467 113.652H237.015V115.103H238.467V113.652Z",
    fill: "#FAFAFA"
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    d: "M238.467 116.085H237.015V117.537H238.467V116.085Z",
    fill: "#FAFAFA"
  })), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    d: "M238.467 123.387H237.015V124.838H238.467V123.387Z",
    fill: "#FAFAFA"
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    d: "M238.467 125.821H237.015V127.272H238.467V125.821Z",
    fill: "#FAFAFA"
  })), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    d: "M238.467 128.255H237.015V129.706H238.467V128.255Z",
    fill: "#FAFAFA"
  })), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    d: "M238.467 130.689H237.015V132.14H238.467V130.689Z",
    fill: "#FAFAFA"
  })), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    d: "M238.467 133.123H237.015V134.574H238.467V133.123Z",
    fill: "#FAFAFA"
  })), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    d: "M238.467 135.557H237.015V137.009H238.467V135.557Z",
    fill: "#FAFAFA"
  })), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    d: "M238.467 137.991H237.015V139.442H238.467V137.991Z",
    fill: "#FAFAFA"
  })), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    d: "M236.161 96.6145H234.708V98.066H236.161V96.6145Z",
    fill: "#FAFAFA"
  })), _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    d: "M236.161 99.0483H234.708V100.5H236.161V99.0483Z",
    fill: "#FAFAFA"
  })), _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    d: "M236.161 101.482H234.708V102.934H236.161V101.482Z",
    fill: "#FAFAFA"
  })), _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    d: "M236.161 103.916H234.708V105.368H236.161V103.916Z",
    fill: "#FAFAFA"
  })), _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    d: "M236.161 106.35H234.708V107.802H236.161V106.35Z",
    fill: "#FAFAFA"
  })), _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    d: "M236.161 108.784H234.708V110.235H236.161V108.784Z",
    fill: "#FAFAFA"
  })), _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    d: "M236.161 116.085H234.708V117.537H236.161V116.085Z",
    fill: "#FAFAFA"
  })), _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    d: "M236.161 118.519H234.708V119.971H236.161V118.519Z",
    fill: "#FAFAFA"
  })), _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    d: "M236.161 120.953H234.708V122.405H236.161V120.953Z",
    fill: "#FAFAFA"
  })), _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    d: "M236.161 123.387H234.708V124.838H236.161V123.387Z",
    fill: "#FAFAFA"
  })), _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
    d: "M236.161 125.821H234.708V127.272H236.161V125.821Z",
    fill: "#FAFAFA"
  })), _path173 || (_path173 = /*#__PURE__*/React.createElement("path", {
    d: "M236.161 128.255H234.708V129.706H236.161V128.255Z",
    fill: "#FAFAFA"
  })), _path174 || (_path174 = /*#__PURE__*/React.createElement("path", {
    d: "M236.161 130.689H234.708V132.14H236.161V130.689Z",
    fill: "#FAFAFA"
  })), _path175 || (_path175 = /*#__PURE__*/React.createElement("path", {
    d: "M236.161 133.123H234.708V134.574H236.161V133.123Z",
    fill: "#FAFAFA"
  })), _path176 || (_path176 = /*#__PURE__*/React.createElement("path", {
    d: "M236.161 135.557H234.708V137.009H236.161V135.557Z",
    fill: "#FAFAFA"
  })), _path177 || (_path177 = /*#__PURE__*/React.createElement("path", {
    d: "M236.161 137.991H234.708V139.442H236.161V137.991Z",
    fill: "#FAFAFA"
  })), _path178 || (_path178 = /*#__PURE__*/React.createElement("path", {
    d: "M236.161 140.425H234.708V141.877H236.161V140.425Z",
    fill: "#FAFAFA"
  })), _path179 || (_path179 = /*#__PURE__*/React.createElement("path", {
    d: "M236.161 145.292H234.708V146.744H236.161V145.292Z",
    fill: "#FAFAFA"
  })), _path180 || (_path180 = /*#__PURE__*/React.createElement("path", {
    d: "M233.855 96.6145H232.403V98.066H233.855V96.6145Z",
    fill: "#FAFAFA"
  })), _path181 || (_path181 = /*#__PURE__*/React.createElement("path", {
    d: "M233.855 99.0483H232.403V100.5H233.855V99.0483Z",
    fill: "#FAFAFA"
  })), _path182 || (_path182 = /*#__PURE__*/React.createElement("path", {
    d: "M233.855 101.482H232.403V102.934H233.855V101.482Z",
    fill: "#FAFAFA"
  })), _path183 || (_path183 = /*#__PURE__*/React.createElement("path", {
    d: "M233.855 103.916H232.403V105.368H233.855V103.916Z",
    fill: "#FAFAFA"
  })), _path184 || (_path184 = /*#__PURE__*/React.createElement("path", {
    d: "M233.855 106.35H232.403V107.802H233.855V106.35Z",
    fill: "#FAFAFA"
  })), _path185 || (_path185 = /*#__PURE__*/React.createElement("path", {
    d: "M233.855 108.784H232.403V110.235H233.855V108.784Z",
    fill: "#FAFAFA"
  })), _path186 || (_path186 = /*#__PURE__*/React.createElement("path", {
    d: "M233.855 116.085H232.403V117.537H233.855V116.085Z",
    fill: "#FAFAFA"
  })), _path187 || (_path187 = /*#__PURE__*/React.createElement("path", {
    d: "M233.855 118.519H232.403V119.971H233.855V118.519Z",
    fill: "#FAFAFA"
  })), _path188 || (_path188 = /*#__PURE__*/React.createElement("path", {
    d: "M233.855 120.953H232.403V122.405H233.855V120.953Z",
    fill: "#FAFAFA"
  })), _path189 || (_path189 = /*#__PURE__*/React.createElement("path", {
    d: "M233.855 123.387H232.403V124.838H233.855V123.387Z",
    fill: "#FAFAFA"
  })), _path190 || (_path190 = /*#__PURE__*/React.createElement("path", {
    d: "M233.855 130.689H232.403V132.14H233.855V130.689Z",
    fill: "#FAFAFA"
  })), _path191 || (_path191 = /*#__PURE__*/React.createElement("path", {
    d: "M233.855 133.123H232.403V134.574H233.855V133.123Z",
    fill: "#FAFAFA"
  })), _path192 || (_path192 = /*#__PURE__*/React.createElement("path", {
    d: "M233.855 135.557H232.403V137.009H233.855V135.557Z",
    fill: "#FAFAFA"
  })), _path193 || (_path193 = /*#__PURE__*/React.createElement("path", {
    d: "M233.855 137.991H232.403V139.442H233.855V137.991Z",
    fill: "#FAFAFA"
  })), _path194 || (_path194 = /*#__PURE__*/React.createElement("path", {
    d: "M233.855 140.425H232.403V141.877H233.855V140.425Z",
    fill: "#FAFAFA"
  })), _path195 || (_path195 = /*#__PURE__*/React.createElement("path", {
    d: "M233.855 145.292H232.403V146.744H233.855V145.292Z",
    fill: "#FAFAFA"
  })), _path196 || (_path196 = /*#__PURE__*/React.createElement("path", {
    d: "M233.855 147.726H232.403V149.178H233.855V147.726Z",
    fill: "#FAFAFA"
  })), _path197 || (_path197 = /*#__PURE__*/React.createElement("path", {
    d: "M212.932 119.245H211.48V120.697H212.932V119.245Z",
    fill: "#FAFAFA"
  })), _path198 || (_path198 = /*#__PURE__*/React.createElement("path", {
    d: "M212.932 121.679H211.48V123.131H212.932V121.679Z",
    fill: "#FAFAFA"
  })), _path199 || (_path199 = /*#__PURE__*/React.createElement("path", {
    d: "M212.932 124.113H211.48V125.565H212.932V124.113Z",
    fill: "#FAFAFA"
  })), _path200 || (_path200 = /*#__PURE__*/React.createElement("path", {
    d: "M212.932 126.547H211.48V127.998H212.932V126.547Z",
    fill: "#FAFAFA"
  })), _path201 || (_path201 = /*#__PURE__*/React.createElement("path", {
    d: "M212.932 128.981H211.48V130.432H212.932V128.981Z",
    fill: "#FAFAFA"
  })), _path202 || (_path202 = /*#__PURE__*/React.createElement("path", {
    d: "M212.932 131.415H211.48V132.866H212.932V131.415Z",
    fill: "#FAFAFA"
  })), _path203 || (_path203 = /*#__PURE__*/React.createElement("path", {
    d: "M212.932 133.849H211.48V135.3H212.932V133.849Z",
    fill: "#FAFAFA"
  })), _path204 || (_path204 = /*#__PURE__*/React.createElement("path", {
    d: "M212.932 141.15H211.48V142.602H212.932V141.15Z",
    fill: "#FAFAFA"
  })), _path205 || (_path205 = /*#__PURE__*/React.createElement("path", {
    d: "M212.932 143.584H211.48V145.035H212.932V143.584Z",
    fill: "#FAFAFA"
  })), _path206 || (_path206 = /*#__PURE__*/React.createElement("path", {
    d: "M212.932 146.018H211.48V147.469H212.932V146.018Z",
    fill: "#FAFAFA"
  })), _path207 || (_path207 = /*#__PURE__*/React.createElement("path", {
    d: "M210.625 119.245H209.174V120.697H210.625V119.245Z",
    fill: "#FAFAFA"
  })), _path208 || (_path208 = /*#__PURE__*/React.createElement("path", {
    d: "M210.625 121.679H209.174V123.131H210.625V121.679Z",
    fill: "#FAFAFA"
  })), _path209 || (_path209 = /*#__PURE__*/React.createElement("path", {
    d: "M210.625 124.113H209.174V125.565H210.625V124.113Z",
    fill: "#FAFAFA"
  })), _path210 || (_path210 = /*#__PURE__*/React.createElement("path", {
    d: "M210.625 126.547H209.174V127.998H210.625V126.547Z",
    fill: "#FAFAFA"
  })), _path211 || (_path211 = /*#__PURE__*/React.createElement("path", {
    d: "M210.625 128.981H209.174V130.432H210.625V128.981Z",
    fill: "#FAFAFA"
  })), _path212 || (_path212 = /*#__PURE__*/React.createElement("path", {
    d: "M210.625 131.415H209.174V132.866H210.625V131.415Z",
    fill: "#FAFAFA"
  })), _path213 || (_path213 = /*#__PURE__*/React.createElement("path", {
    d: "M210.625 133.849H209.174V135.3H210.625V133.849Z",
    fill: "#FAFAFA"
  })), _path214 || (_path214 = /*#__PURE__*/React.createElement("path", {
    d: "M208.32 119.245H206.235V120.697H208.32V119.245Z",
    fill: "#FAFAFA"
  })), _path215 || (_path215 = /*#__PURE__*/React.createElement("path", {
    d: "M208.32 121.679H206.235V123.131H208.32V121.679Z",
    fill: "#FAFAFA"
  })), _path216 || (_path216 = /*#__PURE__*/React.createElement("path", {
    d: "M208.32 124.113H206.235V125.565H208.32V124.113Z",
    fill: "#FAFAFA"
  })), _path217 || (_path217 = /*#__PURE__*/React.createElement("path", {
    d: "M208.32 126.547H206.235V127.998H208.32V126.547Z",
    fill: "#FAFAFA"
  })), _path218 || (_path218 = /*#__PURE__*/React.createElement("path", {
    d: "M208.32 128.981H206.235V130.432H208.32V128.981Z",
    fill: "#FAFAFA"
  })), _path219 || (_path219 = /*#__PURE__*/React.createElement("path", {
    d: "M208.32 131.415H206.235V132.866H208.32V131.415Z",
    fill: "#FAFAFA"
  })), _path220 || (_path220 = /*#__PURE__*/React.createElement("path", {
    d: "M208.32 133.849H206.235V135.3H208.32V133.849Z",
    fill: "#FAFAFA"
  })), _path221 || (_path221 = /*#__PURE__*/React.createElement("path", {
    d: "M335.139 122.405H333.688V123.856H335.139V122.405Z",
    fill: "#FAFAFA"
  })), _path222 || (_path222 = /*#__PURE__*/React.createElement("path", {
    d: "M335.139 124.839H333.688V126.291H335.139V124.839Z",
    fill: "#FAFAFA"
  })), _path223 || (_path223 = /*#__PURE__*/React.createElement("path", {
    d: "M335.139 127.273H333.688V128.725H335.139V127.273Z",
    fill: "#FAFAFA"
  })), _path224 || (_path224 = /*#__PURE__*/React.createElement("path", {
    d: "M335.139 129.707H333.688V131.158H335.139V129.707Z",
    fill: "#FAFAFA"
  })), _path225 || (_path225 = /*#__PURE__*/React.createElement("path", {
    d: "M335.139 132.141H333.688V133.593H335.139V132.141Z",
    fill: "#FAFAFA"
  })), _path226 || (_path226 = /*#__PURE__*/React.createElement("path", {
    d: "M335.139 134.575H333.688V136.027H335.139V134.575Z",
    fill: "#FAFAFA"
  })), _path227 || (_path227 = /*#__PURE__*/React.createElement("path", {
    d: "M335.139 137.009H333.688V138.46H335.139V137.009Z",
    fill: "#FAFAFA"
  })), _path228 || (_path228 = /*#__PURE__*/React.createElement("path", {
    d: "M335.139 139.442H333.688V140.895H335.139V139.442Z",
    fill: "#FAFAFA"
  })), _path229 || (_path229 = /*#__PURE__*/React.createElement("path", {
    d: "M335.139 141.876H333.688V143.329H335.139V141.876Z",
    fill: "#FAFAFA"
  })), _path230 || (_path230 = /*#__PURE__*/React.createElement("path", {
    d: "M335.139 144.31H333.688V145.762H335.139V144.31Z",
    fill: "#FAFAFA"
  })), _path231 || (_path231 = /*#__PURE__*/React.createElement("path", {
    d: "M335.139 146.744H333.688V148.196H335.139V146.744Z",
    fill: "#FAFAFA"
  })), _path232 || (_path232 = /*#__PURE__*/React.createElement("path", {
    d: "M335.139 149.178H333.688V150.629H335.139V149.178Z",
    fill: "#FAFAFA"
  })), _path233 || (_path233 = /*#__PURE__*/React.createElement("path", {
    d: "M335.139 151.612H333.688V153.063H335.139V151.612Z",
    fill: "#FAFAFA"
  })), _path234 || (_path234 = /*#__PURE__*/React.createElement("path", {
    d: "M335.139 154.046H333.688V155.497H335.139V154.046Z",
    fill: "#FAFAFA"
  })), _path235 || (_path235 = /*#__PURE__*/React.createElement("path", {
    d: "M335.139 156.479H333.688V157.932H335.139V156.479Z",
    fill: "#FAFAFA"
  })), _path236 || (_path236 = /*#__PURE__*/React.createElement("path", {
    d: "M335.139 158.913H333.688V160.365H335.139V158.913Z",
    fill: "#FAFAFA"
  })), _path237 || (_path237 = /*#__PURE__*/React.createElement("path", {
    d: "M335.139 161.347H333.688V162.799H335.139V161.347Z",
    fill: "#FAFAFA"
  })), _path238 || (_path238 = /*#__PURE__*/React.createElement("path", {
    d: "M335.139 163.781H333.688V165.233H335.139V163.781Z",
    fill: "#FAFAFA"
  })), _path239 || (_path239 = /*#__PURE__*/React.createElement("path", {
    d: "M335.139 166.216H333.688V167.667H335.139V166.216Z",
    fill: "#FAFAFA"
  })), _path240 || (_path240 = /*#__PURE__*/React.createElement("path", {
    d: "M335.139 168.65H333.688V170.102H335.139V168.65Z",
    fill: "#FAFAFA"
  })), _path241 || (_path241 = /*#__PURE__*/React.createElement("path", {
    d: "M332.833 122.405H331.382V123.856H332.833V122.405Z",
    fill: "#FAFAFA"
  })), _path242 || (_path242 = /*#__PURE__*/React.createElement("path", {
    d: "M332.833 124.839H331.382V126.291H332.833V124.839Z",
    fill: "#FAFAFA"
  })), _path243 || (_path243 = /*#__PURE__*/React.createElement("path", {
    d: "M332.833 127.273H331.382V128.725H332.833V127.273Z",
    fill: "#FAFAFA"
  })), _path244 || (_path244 = /*#__PURE__*/React.createElement("path", {
    d: "M332.833 129.707H331.382V131.158H332.833V129.707Z",
    fill: "#FAFAFA"
  })), _path245 || (_path245 = /*#__PURE__*/React.createElement("path", {
    d: "M332.833 132.141H331.382V133.593H332.833V132.141Z",
    fill: "#FAFAFA"
  })), _path246 || (_path246 = /*#__PURE__*/React.createElement("path", {
    d: "M332.833 134.575H331.382V136.027H332.833V134.575Z",
    fill: "#FAFAFA"
  })), _path247 || (_path247 = /*#__PURE__*/React.createElement("path", {
    d: "M332.833 137.009H331.382V138.46H332.833V137.009Z",
    fill: "#FAFAFA"
  })), _path248 || (_path248 = /*#__PURE__*/React.createElement("path", {
    d: "M332.833 139.442H331.382V140.895H332.833V139.442Z",
    fill: "#FAFAFA"
  })), _path249 || (_path249 = /*#__PURE__*/React.createElement("path", {
    d: "M332.833 141.876H331.382V143.329H332.833V141.876Z",
    fill: "#FAFAFA"
  })), _path250 || (_path250 = /*#__PURE__*/React.createElement("path", {
    d: "M332.833 144.31H331.382V145.762H332.833V144.31Z",
    fill: "#FAFAFA"
  })), _path251 || (_path251 = /*#__PURE__*/React.createElement("path", {
    d: "M332.833 146.744H331.382V148.196H332.833V146.744Z",
    fill: "#FAFAFA"
  })), _path252 || (_path252 = /*#__PURE__*/React.createElement("path", {
    d: "M332.833 149.178H331.382V150.629H332.833V149.178Z",
    fill: "#FAFAFA"
  })), _path253 || (_path253 = /*#__PURE__*/React.createElement("path", {
    d: "M332.833 151.612H331.382V153.063H332.833V151.612Z",
    fill: "#FAFAFA"
  })), _path254 || (_path254 = /*#__PURE__*/React.createElement("path", {
    d: "M332.833 154.046H331.382V155.497H332.833V154.046Z",
    fill: "#FAFAFA"
  })), _path255 || (_path255 = /*#__PURE__*/React.createElement("path", {
    d: "M332.833 156.479H331.382V157.932H332.833V156.479Z",
    fill: "#FAFAFA"
  })), _path256 || (_path256 = /*#__PURE__*/React.createElement("path", {
    d: "M332.833 158.913H331.382V160.365H332.833V158.913Z",
    fill: "#FAFAFA"
  })), _path257 || (_path257 = /*#__PURE__*/React.createElement("path", {
    d: "M332.833 161.347H331.382V162.799H332.833V161.347Z",
    fill: "#FAFAFA"
  })), _path258 || (_path258 = /*#__PURE__*/React.createElement("path", {
    d: "M332.833 163.781H331.382V165.233H332.833V163.781Z",
    fill: "#FAFAFA"
  })), _path259 || (_path259 = /*#__PURE__*/React.createElement("path", {
    d: "M330.527 122.405H329.075V123.856H330.527V122.405Z",
    fill: "#FAFAFA"
  })), _path260 || (_path260 = /*#__PURE__*/React.createElement("path", {
    d: "M330.527 124.839H329.075V126.291H330.527V124.839Z",
    fill: "#FAFAFA"
  })), _path261 || (_path261 = /*#__PURE__*/React.createElement("path", {
    d: "M330.527 127.273H329.075V128.725H330.527V127.273Z",
    fill: "#FAFAFA"
  })), _path262 || (_path262 = /*#__PURE__*/React.createElement("path", {
    d: "M330.527 129.707H329.075V131.158H330.527V129.707Z",
    fill: "#FAFAFA"
  })), _path263 || (_path263 = /*#__PURE__*/React.createElement("path", {
    d: "M330.527 132.141H329.075V133.593H330.527V132.141Z",
    fill: "#FAFAFA"
  })), _path264 || (_path264 = /*#__PURE__*/React.createElement("path", {
    d: "M330.527 134.575H329.075V136.027H330.527V134.575Z",
    fill: "#FAFAFA"
  })), _path265 || (_path265 = /*#__PURE__*/React.createElement("path", {
    d: "M330.527 137.009H329.075V138.46H330.527V137.009Z",
    fill: "#FAFAFA"
  })), _path266 || (_path266 = /*#__PURE__*/React.createElement("path", {
    d: "M330.527 139.442H329.075V140.895H330.527V139.442Z",
    fill: "#FAFAFA"
  })), _path267 || (_path267 = /*#__PURE__*/React.createElement("path", {
    d: "M330.527 141.876H329.075V143.329H330.527V141.876Z",
    fill: "#FAFAFA"
  })), _path268 || (_path268 = /*#__PURE__*/React.createElement("path", {
    d: "M330.527 144.31H329.075V145.762H330.527V144.31Z",
    fill: "#FAFAFA"
  })), _path269 || (_path269 = /*#__PURE__*/React.createElement("path", {
    d: "M330.527 146.744H329.075V148.196H330.527V146.744Z",
    fill: "#FAFAFA"
  })), _path270 || (_path270 = /*#__PURE__*/React.createElement("path", {
    d: "M330.527 149.178H329.075V150.629H330.527V149.178Z",
    fill: "#FAFAFA"
  })), _path271 || (_path271 = /*#__PURE__*/React.createElement("path", {
    d: "M330.527 151.612H329.075V153.063H330.527V151.612Z",
    fill: "#FAFAFA"
  })), _path272 || (_path272 = /*#__PURE__*/React.createElement("path", {
    d: "M330.527 154.046H329.075V155.497H330.527V154.046Z",
    fill: "#FAFAFA"
  })), _path273 || (_path273 = /*#__PURE__*/React.createElement("path", {
    d: "M330.527 156.479H329.075V157.932H330.527V156.479Z",
    fill: "#FAFAFA"
  })), _path274 || (_path274 = /*#__PURE__*/React.createElement("path", {
    d: "M330.527 158.913H329.075V160.365H330.527V158.913Z",
    fill: "#FAFAFA"
  })), _path275 || (_path275 = /*#__PURE__*/React.createElement("path", {
    d: "M330.527 161.347H329.075V162.799H330.527V161.347Z",
    fill: "#FAFAFA"
  })), _path276 || (_path276 = /*#__PURE__*/React.createElement("path", {
    d: "M330.527 163.781H329.075V165.233H330.527V163.781Z",
    fill: "#FAFAFA"
  })), _path277 || (_path277 = /*#__PURE__*/React.createElement("path", {
    d: "M343.765 140.168H342.313V141.62H343.765V140.168Z",
    fill: "#FAFAFA"
  })), _path278 || (_path278 = /*#__PURE__*/React.createElement("path", {
    d: "M343.765 142.602H342.313V144.054H343.765V142.602Z",
    fill: "#FAFAFA"
  })), _path279 || (_path279 = /*#__PURE__*/React.createElement("path", {
    d: "M343.765 145.036H342.313V146.488H343.765V145.036Z",
    fill: "#FAFAFA"
  })), _path280 || (_path280 = /*#__PURE__*/React.createElement("path", {
    d: "M343.765 147.47H342.313V148.921H343.765V147.47Z",
    fill: "#FAFAFA"
  })), _path281 || (_path281 = /*#__PURE__*/React.createElement("path", {
    d: "M343.765 149.904H342.313V151.355H343.765V149.904Z",
    fill: "#FAFAFA"
  })), _path282 || (_path282 = /*#__PURE__*/React.createElement("path", {
    d: "M343.765 152.338H342.313V153.789H343.765V152.338Z",
    fill: "#FAFAFA"
  })), _path283 || (_path283 = /*#__PURE__*/React.createElement("path", {
    d: "M343.765 154.772H342.313V156.223H343.765V154.772Z",
    fill: "#FAFAFA"
  })), _path284 || (_path284 = /*#__PURE__*/React.createElement("path", {
    d: "M343.765 157.206H342.313V158.657H343.765V157.206Z",
    fill: "#FAFAFA"
  })), _path285 || (_path285 = /*#__PURE__*/React.createElement("path", {
    d: "M343.765 159.639H342.313V161.091H343.765V159.639Z",
    fill: "#FAFAFA"
  })), _path286 || (_path286 = /*#__PURE__*/React.createElement("path", {
    d: "M343.765 162.073H342.313V163.525H343.765V162.073Z",
    fill: "#FAFAFA"
  })), _path287 || (_path287 = /*#__PURE__*/React.createElement("path", {
    d: "M343.765 164.507H342.313V165.959H343.765V164.507Z",
    fill: "#FAFAFA"
  })), _path288 || (_path288 = /*#__PURE__*/React.createElement("path", {
    d: "M343.765 166.941H342.313V168.392H343.765V166.941Z",
    fill: "#FAFAFA"
  })), _path289 || (_path289 = /*#__PURE__*/React.createElement("path", {
    d: "M343.765 169.375H342.313V170.826H343.765V169.375Z",
    fill: "#FAFAFA"
  })), _path290 || (_path290 = /*#__PURE__*/React.createElement("path", {
    d: "M341.459 140.168H340.007V141.62H341.459V140.168Z",
    fill: "#FAFAFA"
  })), _path291 || (_path291 = /*#__PURE__*/React.createElement("path", {
    d: "M341.459 142.602H340.007V144.054H341.459V142.602Z",
    fill: "#FAFAFA"
  })), _path292 || (_path292 = /*#__PURE__*/React.createElement("path", {
    d: "M341.459 145.036H340.007V146.488H341.459V145.036Z",
    fill: "#FAFAFA"
  })), _path293 || (_path293 = /*#__PURE__*/React.createElement("path", {
    d: "M341.459 147.47H340.007V148.921H341.459V147.47Z",
    fill: "#FAFAFA"
  })), _path294 || (_path294 = /*#__PURE__*/React.createElement("path", {
    d: "M341.459 149.904H340.007V151.355H341.459V149.904Z",
    fill: "#FAFAFA"
  })), _path295 || (_path295 = /*#__PURE__*/React.createElement("path", {
    d: "M341.459 152.338H340.007V153.789H341.459V152.338Z",
    fill: "#FAFAFA"
  })), _path296 || (_path296 = /*#__PURE__*/React.createElement("path", {
    d: "M341.459 154.772H340.007V156.223H341.459V154.772Z",
    fill: "#FAFAFA"
  })), _path297 || (_path297 = /*#__PURE__*/React.createElement("path", {
    d: "M341.459 157.206H340.007V158.657H341.459V157.206Z",
    fill: "#FAFAFA"
  })), _path298 || (_path298 = /*#__PURE__*/React.createElement("path", {
    d: "M341.459 159.639H340.007V161.091H341.459V159.639Z",
    fill: "#FAFAFA"
  })), _path299 || (_path299 = /*#__PURE__*/React.createElement("path", {
    d: "M341.459 162.073H340.007V163.525H341.459V162.073Z",
    fill: "#FAFAFA"
  })), _path300 || (_path300 = /*#__PURE__*/React.createElement("path", {
    d: "M341.459 164.507H340.007V165.959H341.459V164.507Z",
    fill: "#FAFAFA"
  })), _path301 || (_path301 = /*#__PURE__*/React.createElement("path", {
    d: "M341.459 166.941H340.007V168.392H341.459V166.941Z",
    fill: "#FAFAFA"
  })), _path302 || (_path302 = /*#__PURE__*/React.createElement("path", {
    d: "M341.459 169.375H340.007V170.826H341.459V169.375Z",
    fill: "#FAFAFA"
  })), _path303 || (_path303 = /*#__PURE__*/React.createElement("path", {
    d: "M339.154 140.168H337.701V141.62H339.154V140.168Z",
    fill: "#FAFAFA"
  })), _path304 || (_path304 = /*#__PURE__*/React.createElement("path", {
    d: "M339.154 142.602H337.701V144.054H339.154V142.602Z",
    fill: "#FAFAFA"
  })), _path305 || (_path305 = /*#__PURE__*/React.createElement("path", {
    d: "M339.154 145.036H337.701V146.488H339.154V145.036Z",
    fill: "#FAFAFA"
  })), _path306 || (_path306 = /*#__PURE__*/React.createElement("path", {
    d: "M339.154 147.47H337.701V148.921H339.154V147.47Z",
    fill: "#FAFAFA"
  })), _path307 || (_path307 = /*#__PURE__*/React.createElement("path", {
    d: "M339.154 149.904H337.701V151.355H339.154V149.904Z",
    fill: "#FAFAFA"
  })), _path308 || (_path308 = /*#__PURE__*/React.createElement("path", {
    d: "M339.154 152.338H337.701V153.789H339.154V152.338Z",
    fill: "#FAFAFA"
  })), _path309 || (_path309 = /*#__PURE__*/React.createElement("path", {
    d: "M339.154 154.772H337.701V156.223H339.154V154.772Z",
    fill: "#FAFAFA"
  })), _path310 || (_path310 = /*#__PURE__*/React.createElement("path", {
    d: "M339.154 157.206H337.701V158.657H339.154V157.206Z",
    fill: "#FAFAFA"
  })), _path311 || (_path311 = /*#__PURE__*/React.createElement("path", {
    d: "M339.154 159.639H337.701V161.091H339.154V159.639Z",
    fill: "#FAFAFA"
  })), _path312 || (_path312 = /*#__PURE__*/React.createElement("path", {
    d: "M339.154 162.073H337.701V163.525H339.154V162.073Z",
    fill: "#FAFAFA"
  })), _path313 || (_path313 = /*#__PURE__*/React.createElement("path", {
    d: "M339.154 164.507H337.701V165.959H339.154V164.507Z",
    fill: "#FAFAFA"
  })), _path314 || (_path314 = /*#__PURE__*/React.createElement("path", {
    d: "M339.154 166.941H337.701V168.392H339.154V166.941Z",
    fill: "#FAFAFA"
  })), _path315 || (_path315 = /*#__PURE__*/React.createElement("path", {
    d: "M339.154 169.375H337.701V170.826H339.154V169.375Z",
    fill: "#FAFAFA"
  })), _path316 || (_path316 = /*#__PURE__*/React.createElement("path", {
    d: "M339.154 171.81H337.701V173.261H339.154V171.81Z",
    fill: "#FAFAFA"
  })), _path317 || (_path317 = /*#__PURE__*/React.createElement("path", {
    d: "M326.344 140.894H324.891V142.346H326.344V140.894Z",
    fill: "#FAFAFA"
  })), _path318 || (_path318 = /*#__PURE__*/React.createElement("path", {
    d: "M326.344 143.328H324.891V144.779H326.344V143.328Z",
    fill: "#FAFAFA"
  })), _path319 || (_path319 = /*#__PURE__*/React.createElement("path", {
    d: "M326.344 145.762H324.891V147.213H326.344V145.762Z",
    fill: "#FAFAFA"
  })), _path320 || (_path320 = /*#__PURE__*/React.createElement("path", {
    d: "M326.344 148.196H324.891V149.648H326.344V148.196Z",
    fill: "#FAFAFA"
  })), _path321 || (_path321 = /*#__PURE__*/React.createElement("path", {
    d: "M326.344 150.63H324.891V152.081H326.344V150.63Z",
    fill: "#FAFAFA"
  })), _path322 || (_path322 = /*#__PURE__*/React.createElement("path", {
    d: "M326.344 153.064H324.891V154.515H326.344V153.064Z",
    fill: "#FAFAFA"
  })), _path323 || (_path323 = /*#__PURE__*/React.createElement("path", {
    d: "M326.344 155.498H324.891V156.949H326.344V155.498Z",
    fill: "#FAFAFA"
  })), _path324 || (_path324 = /*#__PURE__*/React.createElement("path", {
    d: "M326.344 157.932H324.891V159.383H326.344V157.932Z",
    fill: "#FAFAFA"
  })), _path325 || (_path325 = /*#__PURE__*/React.createElement("path", {
    d: "M326.344 160.365H324.891V161.817H326.344V160.365Z",
    fill: "#FAFAFA"
  })), _path326 || (_path326 = /*#__PURE__*/React.createElement("path", {
    d: "M326.344 162.799H324.891V164.251H326.344V162.799Z",
    fill: "#FAFAFA"
  })), _path327 || (_path327 = /*#__PURE__*/React.createElement("path", {
    d: "M326.344 170.101H324.891V171.552H326.344V170.101Z",
    fill: "#FAFAFA"
  })), _path328 || (_path328 = /*#__PURE__*/React.createElement("path", {
    d: "M324.037 140.894H322.585V142.346H324.037V140.894Z",
    fill: "#FAFAFA"
  })), _path329 || (_path329 = /*#__PURE__*/React.createElement("path", {
    d: "M324.037 143.328H322.585V144.779H324.037V143.328Z",
    fill: "#FAFAFA"
  })), _path330 || (_path330 = /*#__PURE__*/React.createElement("path", {
    d: "M324.037 145.762H322.585V147.213H324.037V145.762Z",
    fill: "#FAFAFA"
  })), _path331 || (_path331 = /*#__PURE__*/React.createElement("path", {
    d: "M324.037 148.196H322.585V149.648H324.037V148.196Z",
    fill: "#FAFAFA"
  })), _path332 || (_path332 = /*#__PURE__*/React.createElement("path", {
    d: "M324.037 150.63H322.585V152.081H324.037V150.63Z",
    fill: "#FAFAFA"
  })), _path333 || (_path333 = /*#__PURE__*/React.createElement("path", {
    d: "M324.037 153.064H322.585V154.515H324.037V153.064Z",
    fill: "#FAFAFA"
  })), _path334 || (_path334 = /*#__PURE__*/React.createElement("path", {
    d: "M324.037 155.498H322.585V156.949H324.037V155.498Z",
    fill: "#FAFAFA"
  })), _path335 || (_path335 = /*#__PURE__*/React.createElement("path", {
    d: "M324.037 157.932H322.585V159.383H324.037V157.932Z",
    fill: "#FAFAFA"
  })), _path336 || (_path336 = /*#__PURE__*/React.createElement("path", {
    d: "M324.037 160.365H322.585V161.817H324.037V160.365Z",
    fill: "#FAFAFA"
  })), _path337 || (_path337 = /*#__PURE__*/React.createElement("path", {
    d: "M324.037 167.667H322.585V169.118H324.037V167.667Z",
    fill: "#FAFAFA"
  })), _path338 || (_path338 = /*#__PURE__*/React.createElement("path", {
    d: "M324.037 170.101H322.585V171.552H324.037V170.101Z",
    fill: "#FAFAFA"
  })), _path339 || (_path339 = /*#__PURE__*/React.createElement("path", {
    d: "M321.732 140.894H320.28V142.346H321.732V140.894Z",
    fill: "#FAFAFA"
  })), _path340 || (_path340 = /*#__PURE__*/React.createElement("path", {
    d: "M321.732 143.328H320.28V144.779H321.732V143.328Z",
    fill: "#FAFAFA"
  })), _path341 || (_path341 = /*#__PURE__*/React.createElement("path", {
    d: "M321.732 145.762H320.28V147.213H321.732V145.762Z",
    fill: "#FAFAFA"
  })), _path342 || (_path342 = /*#__PURE__*/React.createElement("path", {
    d: "M321.732 148.196H320.28V149.648H321.732V148.196Z",
    fill: "#FAFAFA"
  })), _path343 || (_path343 = /*#__PURE__*/React.createElement("path", {
    d: "M321.732 150.63H320.28V152.081H321.732V150.63Z",
    fill: "#FAFAFA"
  })), _path344 || (_path344 = /*#__PURE__*/React.createElement("path", {
    d: "M321.732 153.064H320.28V154.515H321.732V153.064Z",
    fill: "#FAFAFA"
  })), _path345 || (_path345 = /*#__PURE__*/React.createElement("path", {
    d: "M321.732 155.498H320.28V156.949H321.732V155.498Z",
    fill: "#FAFAFA"
  })), _path346 || (_path346 = /*#__PURE__*/React.createElement("path", {
    d: "M321.732 157.932H320.28V159.383H321.732V157.932Z",
    fill: "#FAFAFA"
  })), _path347 || (_path347 = /*#__PURE__*/React.createElement("path", {
    d: "M321.732 165.233H320.28V166.685H321.732V165.233Z",
    fill: "#FAFAFA"
  })), _path348 || (_path348 = /*#__PURE__*/React.createElement("path", {
    d: "M321.732 167.667H320.28V169.118H321.732V167.667Z",
    fill: "#FAFAFA"
  })), _path349 || (_path349 = /*#__PURE__*/React.createElement("path", {
    d: "M321.732 170.101H320.28V171.552H321.732V170.101Z",
    fill: "#FAFAFA"
  })), _path350 || (_path350 = /*#__PURE__*/React.createElement("path", {
    d: "M300.295 103.916H298.844V105.368H300.295V103.916Z",
    fill: "#FAFAFA"
  })), _path351 || (_path351 = /*#__PURE__*/React.createElement("path", {
    d: "M300.295 106.35H298.844V107.802H300.295V106.35Z",
    fill: "#FAFAFA"
  })), _path352 || (_path352 = /*#__PURE__*/React.createElement("path", {
    d: "M300.295 108.784H298.844V110.235H300.295V108.784Z",
    fill: "#FAFAFA"
  })), _path353 || (_path353 = /*#__PURE__*/React.createElement("path", {
    d: "M300.295 111.218H298.844V112.669H300.295V111.218Z",
    fill: "#FAFAFA"
  })), _path354 || (_path354 = /*#__PURE__*/React.createElement("path", {
    d: "M300.295 113.652H298.844V115.103H300.295V113.652Z",
    fill: "#FAFAFA"
  })), _path355 || (_path355 = /*#__PURE__*/React.createElement("path", {
    d: "M300.295 116.085H298.844V117.537H300.295V116.085Z",
    fill: "#FAFAFA"
  })), _path356 || (_path356 = /*#__PURE__*/React.createElement("path", {
    d: "M300.295 118.519H298.844V119.971H300.295V118.519Z",
    fill: "#FAFAFA"
  })), _path357 || (_path357 = /*#__PURE__*/React.createElement("path", {
    d: "M300.295 120.953H298.844V122.405H300.295V120.953Z",
    fill: "#FAFAFA"
  })), _path358 || (_path358 = /*#__PURE__*/React.createElement("path", {
    d: "M300.295 123.387H298.844V124.838H300.295V123.387Z",
    fill: "#FAFAFA"
  })), _path359 || (_path359 = /*#__PURE__*/React.createElement("path", {
    d: "M300.295 125.821H298.844V127.272H300.295V125.821Z",
    fill: "#FAFAFA"
  })), _path360 || (_path360 = /*#__PURE__*/React.createElement("path", {
    d: "M300.295 128.255H298.844V129.706H300.295V128.255Z",
    fill: "#FAFAFA"
  })), _path361 || (_path361 = /*#__PURE__*/React.createElement("path", {
    d: "M300.295 130.689H298.844V132.14H300.295V130.689Z",
    fill: "#FAFAFA"
  })), _path362 || (_path362 = /*#__PURE__*/React.createElement("path", {
    d: "M300.295 133.123H298.844V134.574H300.295V133.123Z",
    fill: "#FAFAFA"
  })), _path363 || (_path363 = /*#__PURE__*/React.createElement("path", {
    d: "M300.295 135.557H298.844V137.009H300.295V135.557Z",
    fill: "#FAFAFA"
  })), _path364 || (_path364 = /*#__PURE__*/React.createElement("path", {
    d: "M300.295 137.991H298.844V139.442H300.295V137.991Z",
    fill: "#FAFAFA"
  })), _path365 || (_path365 = /*#__PURE__*/React.createElement("path", {
    d: "M300.295 140.425H298.844V141.877H300.295V140.425Z",
    fill: "#FAFAFA"
  })), _path366 || (_path366 = /*#__PURE__*/React.createElement("path", {
    d: "M300.295 142.858H298.844V144.31H300.295V142.858Z",
    fill: "#FAFAFA"
  })), _path367 || (_path367 = /*#__PURE__*/React.createElement("path", {
    d: "M300.295 147.726H298.844V149.178H300.295V147.726Z",
    fill: "#FAFAFA"
  })), _path368 || (_path368 = /*#__PURE__*/React.createElement("path", {
    d: "M300.295 150.16H298.844V151.612H300.295V150.16Z",
    fill: "#FAFAFA"
  })), _path369 || (_path369 = /*#__PURE__*/React.createElement("path", {
    d: "M300.295 152.594H298.844V154.045H300.295V152.594Z",
    fill: "#FAFAFA"
  })), _path370 || (_path370 = /*#__PURE__*/React.createElement("path", {
    d: "M300.295 155.028H298.844V156.479H300.295V155.028Z",
    fill: "#FAFAFA"
  })), _path371 || (_path371 = /*#__PURE__*/React.createElement("path", {
    d: "M300.295 157.462H298.844V158.913H300.295V157.462Z",
    fill: "#FAFAFA"
  })), _path372 || (_path372 = /*#__PURE__*/React.createElement("path", {
    d: "M297.989 103.916H296.538V105.368H297.989V103.916Z",
    fill: "#FAFAFA"
  })), _path373 || (_path373 = /*#__PURE__*/React.createElement("path", {
    d: "M297.989 106.35H296.538V107.802H297.989V106.35Z",
    fill: "#FAFAFA"
  })), _path374 || (_path374 = /*#__PURE__*/React.createElement("path", {
    d: "M297.989 108.784H296.538V110.235H297.989V108.784Z",
    fill: "#FAFAFA"
  })), _path375 || (_path375 = /*#__PURE__*/React.createElement("path", {
    d: "M297.989 111.218H296.538V112.669H297.989V111.218Z",
    fill: "#FAFAFA"
  })), _path376 || (_path376 = /*#__PURE__*/React.createElement("path", {
    d: "M297.989 113.652H296.538V115.103H297.989V113.652Z",
    fill: "#FAFAFA"
  })), _path377 || (_path377 = /*#__PURE__*/React.createElement("path", {
    d: "M297.989 116.085H296.538V117.537H297.989V116.085Z",
    fill: "#FAFAFA"
  })), _path378 || (_path378 = /*#__PURE__*/React.createElement("path", {
    d: "M297.989 118.519H296.538V119.971H297.989V118.519Z",
    fill: "#FAFAFA"
  })), _path379 || (_path379 = /*#__PURE__*/React.createElement("path", {
    d: "M297.989 120.953H296.538V122.405H297.989V120.953Z",
    fill: "#FAFAFA"
  })), _path380 || (_path380 = /*#__PURE__*/React.createElement("path", {
    d: "M297.989 123.387H296.538V124.838H297.989V123.387Z",
    fill: "#FAFAFA"
  })), _path381 || (_path381 = /*#__PURE__*/React.createElement("path", {
    d: "M297.989 125.821H296.538V127.272H297.989V125.821Z",
    fill: "#FAFAFA"
  })), _path382 || (_path382 = /*#__PURE__*/React.createElement("path", {
    d: "M297.989 128.255H296.538V129.706H297.989V128.255Z",
    fill: "#FAFAFA"
  })), _path383 || (_path383 = /*#__PURE__*/React.createElement("path", {
    d: "M297.989 130.689H296.538V132.14H297.989V130.689Z",
    fill: "#FAFAFA"
  })), _path384 || (_path384 = /*#__PURE__*/React.createElement("path", {
    d: "M297.989 133.123H296.538V134.574H297.989V133.123Z",
    fill: "#FAFAFA"
  })), _path385 || (_path385 = /*#__PURE__*/React.createElement("path", {
    d: "M297.989 135.557H296.538V137.009H297.989V135.557Z",
    fill: "#FAFAFA"
  })), _path386 || (_path386 = /*#__PURE__*/React.createElement("path", {
    d: "M297.989 137.991H296.538V139.442H297.989V137.991Z",
    fill: "#FAFAFA"
  })), _path387 || (_path387 = /*#__PURE__*/React.createElement("path", {
    d: "M297.989 140.425H296.538V141.877H297.989V140.425Z",
    fill: "#FAFAFA"
  })), _path388 || (_path388 = /*#__PURE__*/React.createElement("path", {
    d: "M297.989 155.028H296.538V156.479H297.989V155.028Z",
    fill: "#FAFAFA"
  })), _path389 || (_path389 = /*#__PURE__*/React.createElement("path", {
    d: "M297.989 157.462H296.538V158.913H297.989V157.462Z",
    fill: "#FAFAFA"
  })), _path390 || (_path390 = /*#__PURE__*/React.createElement("path", {
    d: "M295.684 103.916H294.233V105.368H295.684V103.916Z",
    fill: "#FAFAFA"
  })), _path391 || (_path391 = /*#__PURE__*/React.createElement("path", {
    d: "M295.684 106.35H294.233V107.802H295.684V106.35Z",
    fill: "#FAFAFA"
  })), _path392 || (_path392 = /*#__PURE__*/React.createElement("path", {
    d: "M295.684 108.784H294.233V110.235H295.684V108.784Z",
    fill: "#FAFAFA"
  })), _path393 || (_path393 = /*#__PURE__*/React.createElement("path", {
    d: "M295.684 111.218H294.233V112.669H295.684V111.218Z",
    fill: "#FAFAFA"
  })), _path394 || (_path394 = /*#__PURE__*/React.createElement("path", {
    d: "M295.684 113.652H294.233V115.103H295.684V113.652Z",
    fill: "#FAFAFA"
  })), _path395 || (_path395 = /*#__PURE__*/React.createElement("path", {
    d: "M295.684 116.085H294.233V117.537H295.684V116.085Z",
    fill: "#FAFAFA"
  })), _path396 || (_path396 = /*#__PURE__*/React.createElement("path", {
    d: "M295.684 118.519H294.233V119.971H295.684V118.519Z",
    fill: "#FAFAFA"
  })), _path397 || (_path397 = /*#__PURE__*/React.createElement("path", {
    d: "M295.684 120.953H294.233V122.405H295.684V120.953Z",
    fill: "#FAFAFA"
  })), _path398 || (_path398 = /*#__PURE__*/React.createElement("path", {
    d: "M295.684 123.387H294.233V124.838H295.684V123.387Z",
    fill: "#FAFAFA"
  })), _path399 || (_path399 = /*#__PURE__*/React.createElement("path", {
    d: "M295.684 125.821H294.233V127.272H295.684V125.821Z",
    fill: "#FAFAFA"
  })), _path400 || (_path400 = /*#__PURE__*/React.createElement("path", {
    d: "M295.684 128.255H294.233V129.706H295.684V128.255Z",
    fill: "#FAFAFA"
  })), _path401 || (_path401 = /*#__PURE__*/React.createElement("path", {
    d: "M295.684 130.689H294.233V132.14H295.684V130.689Z",
    fill: "#FAFAFA"
  })), _path402 || (_path402 = /*#__PURE__*/React.createElement("path", {
    d: "M295.684 133.123H294.233V134.574H295.684V133.123Z",
    fill: "#FAFAFA"
  })), _path403 || (_path403 = /*#__PURE__*/React.createElement("path", {
    d: "M295.684 135.557H294.233V137.009H295.684V135.557Z",
    fill: "#FAFAFA"
  })), _path404 || (_path404 = /*#__PURE__*/React.createElement("path", {
    d: "M295.684 137.991H294.233V139.442H295.684V137.991Z",
    fill: "#FAFAFA"
  })), _path405 || (_path405 = /*#__PURE__*/React.createElement("path", {
    d: "M295.684 140.425H294.233V141.877H295.684V140.425Z",
    fill: "#FAFAFA"
  })), _path406 || (_path406 = /*#__PURE__*/React.createElement("path", {
    d: "M295.684 145.292H294.233V146.744H295.684V145.292Z",
    fill: "#FAFAFA"
  })), _path407 || (_path407 = /*#__PURE__*/React.createElement("path", {
    d: "M295.684 147.726H294.233V149.178H295.684V147.726Z",
    fill: "#FAFAFA"
  })), _path408 || (_path408 = /*#__PURE__*/React.createElement("path", {
    d: "M295.684 150.16H294.233V151.612H295.684V150.16Z",
    fill: "#FAFAFA"
  })), _path409 || (_path409 = /*#__PURE__*/React.createElement("path", {
    d: "M295.684 152.594H294.233V154.045H295.684V152.594Z",
    fill: "#FAFAFA"
  })), _path410 || (_path410 = /*#__PURE__*/React.createElement("path", {
    d: "M295.684 157.462H294.233V158.913H295.684V157.462Z",
    fill: "#FAFAFA"
  })), _path411 || (_path411 = /*#__PURE__*/React.createElement("path", {
    d: "M308.665 134.575H307.213V136.027H308.665V134.575Z",
    fill: "#FAFAFA"
  })), _path412 || (_path412 = /*#__PURE__*/React.createElement("path", {
    d: "M308.665 137.009H307.213V138.46H308.665V137.009Z",
    fill: "#FAFAFA"
  })), _path413 || (_path413 = /*#__PURE__*/React.createElement("path", {
    d: "M308.665 139.442H307.213V140.895H308.665V139.442Z",
    fill: "#FAFAFA"
  })), _path414 || (_path414 = /*#__PURE__*/React.createElement("path", {
    d: "M308.665 141.876H307.213V143.329H308.665V141.876Z",
    fill: "#FAFAFA"
  })), _path415 || (_path415 = /*#__PURE__*/React.createElement("path", {
    d: "M308.665 144.31H307.213V145.762H308.665V144.31Z",
    fill: "#FAFAFA"
  })), _path416 || (_path416 = /*#__PURE__*/React.createElement("path", {
    d: "M308.665 146.744H307.213V148.196H308.665V146.744Z",
    fill: "#FAFAFA"
  })), _path417 || (_path417 = /*#__PURE__*/React.createElement("path", {
    d: "M308.665 149.178H307.213V150.629H308.665V149.178Z",
    fill: "#FAFAFA"
  })), _path418 || (_path418 = /*#__PURE__*/React.createElement("path", {
    d: "M308.665 154.046H307.213V155.497H308.665V154.046Z",
    fill: "#FAFAFA"
  })), _path419 || (_path419 = /*#__PURE__*/React.createElement("path", {
    d: "M308.665 156.479H307.213V157.932H308.665V156.479Z",
    fill: "#FAFAFA"
  })), _path420 || (_path420 = /*#__PURE__*/React.createElement("path", {
    d: "M308.665 158.913H307.213V160.365H308.665V158.913Z",
    fill: "#FAFAFA"
  })), _path421 || (_path421 = /*#__PURE__*/React.createElement("path", {
    d: "M308.665 161.347H307.213V162.799H308.665V161.347Z",
    fill: "#FAFAFA"
  })), _path422 || (_path422 = /*#__PURE__*/React.createElement("path", {
    d: "M308.665 163.781H307.213V165.233H308.665V163.781Z",
    fill: "#FAFAFA"
  })), _path423 || (_path423 = /*#__PURE__*/React.createElement("path", {
    d: "M308.665 166.216H307.213V167.667H308.665V166.216Z",
    fill: "#FAFAFA"
  })), _path424 || (_path424 = /*#__PURE__*/React.createElement("path", {
    d: "M308.665 168.65H307.213V170.102H308.665V168.65Z",
    fill: "#FAFAFA"
  })), _path425 || (_path425 = /*#__PURE__*/React.createElement("path", {
    d: "M308.665 171.083H307.213V172.536H308.665V171.083Z",
    fill: "#FAFAFA"
  })), _path426 || (_path426 = /*#__PURE__*/React.createElement("path", {
    d: "M306.36 134.575H304.907V136.027H306.36V134.575Z",
    fill: "#FAFAFA"
  })), _path427 || (_path427 = /*#__PURE__*/React.createElement("path", {
    d: "M306.36 137.009H304.907V138.46H306.36V137.009Z",
    fill: "#FAFAFA"
  })), _path428 || (_path428 = /*#__PURE__*/React.createElement("path", {
    d: "M306.36 139.442H304.907V140.895H306.36V139.442Z",
    fill: "#FAFAFA"
  })), _path429 || (_path429 = /*#__PURE__*/React.createElement("path", {
    d: "M306.36 141.876H304.907V143.329H306.36V141.876Z",
    fill: "#FAFAFA"
  })), _path430 || (_path430 = /*#__PURE__*/React.createElement("path", {
    d: "M306.36 144.31H304.907V145.762H306.36V144.31Z",
    fill: "#FAFAFA"
  })), _path431 || (_path431 = /*#__PURE__*/React.createElement("path", {
    d: "M306.36 146.744H304.907V148.196H306.36V146.744Z",
    fill: "#FAFAFA"
  })), _path432 || (_path432 = /*#__PURE__*/React.createElement("path", {
    d: "M306.36 154.046H304.907V155.497H306.36V154.046Z",
    fill: "#FAFAFA"
  })), _path433 || (_path433 = /*#__PURE__*/React.createElement("path", {
    d: "M306.36 156.479H304.907V157.932H306.36V156.479Z",
    fill: "#FAFAFA"
  })), _path434 || (_path434 = /*#__PURE__*/React.createElement("path", {
    d: "M306.36 158.913H304.907V160.365H306.36V158.913Z",
    fill: "#FAFAFA"
  })), _path435 || (_path435 = /*#__PURE__*/React.createElement("path", {
    d: "M306.36 161.347H304.907V162.799H306.36V161.347Z",
    fill: "#FAFAFA"
  })), _path436 || (_path436 = /*#__PURE__*/React.createElement("path", {
    d: "M306.36 163.781H304.907V165.233H306.36V163.781Z",
    fill: "#FAFAFA"
  })), _path437 || (_path437 = /*#__PURE__*/React.createElement("path", {
    d: "M306.36 166.216H304.907V167.667H306.36V166.216Z",
    fill: "#FAFAFA"
  })), _path438 || (_path438 = /*#__PURE__*/React.createElement("path", {
    d: "M306.36 168.65H304.907V170.102H306.36V168.65Z",
    fill: "#FAFAFA"
  })), _path439 || (_path439 = /*#__PURE__*/React.createElement("path", {
    d: "M306.36 171.083H304.907V172.536H306.36V171.083Z",
    fill: "#FAFAFA"
  })), _path440 || (_path440 = /*#__PURE__*/React.createElement("path", {
    d: "M304.054 134.575H302.602V136.027H304.054V134.575Z",
    fill: "#FAFAFA"
  })), _path441 || (_path441 = /*#__PURE__*/React.createElement("path", {
    d: "M304.054 137.009H302.602V138.46H304.054V137.009Z",
    fill: "#FAFAFA"
  })), _path442 || (_path442 = /*#__PURE__*/React.createElement("path", {
    d: "M304.054 139.442H302.602V140.895H304.054V139.442Z",
    fill: "#FAFAFA"
  })), _path443 || (_path443 = /*#__PURE__*/React.createElement("path", {
    d: "M304.054 141.876H302.602V143.329H304.054V141.876Z",
    fill: "#FAFAFA"
  })), _path444 || (_path444 = /*#__PURE__*/React.createElement("path", {
    d: "M304.054 144.31H302.602V145.762H304.054V144.31Z",
    fill: "#FAFAFA"
  })), _path445 || (_path445 = /*#__PURE__*/React.createElement("path", {
    d: "M304.054 146.744H302.602V148.196H304.054V146.744Z",
    fill: "#FAFAFA"
  })), _path446 || (_path446 = /*#__PURE__*/React.createElement("path", {
    d: "M304.054 151.612H302.602V153.063H304.054V151.612Z",
    fill: "#FAFAFA"
  })), _path447 || (_path447 = /*#__PURE__*/React.createElement("path", {
    d: "M304.054 154.046H302.602V155.497H304.054V154.046Z",
    fill: "#FAFAFA"
  })), _path448 || (_path448 = /*#__PURE__*/React.createElement("path", {
    d: "M304.054 156.479H302.602V157.932H304.054V156.479Z",
    fill: "#FAFAFA"
  })), _path449 || (_path449 = /*#__PURE__*/React.createElement("path", {
    d: "M304.054 158.913H302.602V160.365H304.054V158.913Z",
    fill: "#FAFAFA"
  })), _path450 || (_path450 = /*#__PURE__*/React.createElement("path", {
    d: "M304.054 161.347H302.602V162.799H304.054V161.347Z",
    fill: "#FAFAFA"
  })), _path451 || (_path451 = /*#__PURE__*/React.createElement("path", {
    d: "M304.054 163.781H302.602V165.233H304.054V163.781Z",
    fill: "#FAFAFA"
  })), _path452 || (_path452 = /*#__PURE__*/React.createElement("path", {
    d: "M304.054 166.216H302.602V167.667H304.054V166.216Z",
    fill: "#FAFAFA"
  })), _path453 || (_path453 = /*#__PURE__*/React.createElement("path", {
    d: "M304.054 168.65H302.602V170.102H304.054V168.65Z",
    fill: "#FAFAFA"
  })), _path454 || (_path454 = /*#__PURE__*/React.createElement("path", {
    d: "M304.054 171.083H302.602V172.536H304.054V171.083Z",
    fill: "#FAFAFA"
  })), _path455 || (_path455 = /*#__PURE__*/React.createElement("path", {
    d: "M255.461 120.953H254.009V122.405H255.461V120.953Z",
    fill: "#FAFAFA"
  })), _path456 || (_path456 = /*#__PURE__*/React.createElement("path", {
    d: "M255.461 123.387H254.009V124.838H255.461V123.387Z",
    fill: "#FAFAFA"
  })), _path457 || (_path457 = /*#__PURE__*/React.createElement("path", {
    d: "M255.461 125.821H254.009V127.272H255.461V125.821Z",
    fill: "#FAFAFA"
  })), _path458 || (_path458 = /*#__PURE__*/React.createElement("path", {
    d: "M255.461 128.255H254.009V129.706H255.461V128.255Z",
    fill: "#FAFAFA"
  })), _path459 || (_path459 = /*#__PURE__*/React.createElement("path", {
    d: "M255.461 130.689H254.009V132.14H255.461V130.689Z",
    fill: "#FAFAFA"
  })), _path460 || (_path460 = /*#__PURE__*/React.createElement("path", {
    d: "M255.461 133.123H254.009V134.574H255.461V133.123Z",
    fill: "#FAFAFA"
  })), _path461 || (_path461 = /*#__PURE__*/React.createElement("path", {
    d: "M255.461 135.557H254.009V137.009H255.461V135.557Z",
    fill: "#FAFAFA"
  })), _path462 || (_path462 = /*#__PURE__*/React.createElement("path", {
    d: "M255.461 137.991H254.009V139.442H255.461V137.991Z",
    fill: "#FAFAFA"
  })), _path463 || (_path463 = /*#__PURE__*/React.createElement("path", {
    d: "M255.461 140.425H254.009V141.877H255.461V140.425Z",
    fill: "#FAFAFA"
  })), _path464 || (_path464 = /*#__PURE__*/React.createElement("path", {
    d: "M255.461 142.858H254.009V144.31H255.461V142.858Z",
    fill: "#FAFAFA"
  })), _path465 || (_path465 = /*#__PURE__*/React.createElement("path", {
    d: "M255.461 145.292H254.009V146.744H255.461V145.292Z",
    fill: "#FAFAFA"
  })), _path466 || (_path466 = /*#__PURE__*/React.createElement("path", {
    d: "M255.461 147.726H254.009V149.178H255.461V147.726Z",
    fill: "#FAFAFA"
  })), _path467 || (_path467 = /*#__PURE__*/React.createElement("path", {
    d: "M255.461 150.16H254.009V151.612H255.461V150.16Z",
    fill: "#FAFAFA"
  })), _path468 || (_path468 = /*#__PURE__*/React.createElement("path", {
    d: "M255.461 155.028H254.009V156.479H255.461V155.028Z",
    fill: "#FAFAFA"
  })), _path469 || (_path469 = /*#__PURE__*/React.createElement("path", {
    d: "M255.461 157.462H254.009V158.913H255.461V157.462Z",
    fill: "#FAFAFA"
  })), _path470 || (_path470 = /*#__PURE__*/React.createElement("path", {
    d: "M255.461 159.896H254.009V161.347H255.461V159.896Z",
    fill: "#FAFAFA"
  })), _path471 || (_path471 = /*#__PURE__*/React.createElement("path", {
    d: "M255.461 162.329H254.009V163.781H255.461V162.329Z",
    fill: "#FAFAFA"
  })), _path472 || (_path472 = /*#__PURE__*/React.createElement("path", {
    d: "M255.461 167.197H254.009V168.648H255.461V167.197Z",
    fill: "#FAFAFA"
  })), _path473 || (_path473 = /*#__PURE__*/React.createElement("path", {
    d: "M255.461 169.631H254.009V171.082H255.461V169.631Z",
    fill: "#FAFAFA"
  })), _path474 || (_path474 = /*#__PURE__*/React.createElement("path", {
    d: "M255.461 172.065H254.009V173.516H255.461V172.065Z",
    fill: "#FAFAFA"
  })), _path475 || (_path475 = /*#__PURE__*/React.createElement("path", {
    d: "M253.155 120.953H251.704V122.405H253.155V120.953Z",
    fill: "#FAFAFA"
  })), _path476 || (_path476 = /*#__PURE__*/React.createElement("path", {
    d: "M253.155 123.387H251.704V124.838H253.155V123.387Z",
    fill: "#FAFAFA"
  })), _path477 || (_path477 = /*#__PURE__*/React.createElement("path", {
    d: "M253.155 125.821H251.704V127.272H253.155V125.821Z",
    fill: "#FAFAFA"
  })), _path478 || (_path478 = /*#__PURE__*/React.createElement("path", {
    d: "M253.155 128.255H251.704V129.706H253.155V128.255Z",
    fill: "#FAFAFA"
  })), _path479 || (_path479 = /*#__PURE__*/React.createElement("path", {
    d: "M253.155 130.689H251.704V132.14H253.155V130.689Z",
    fill: "#FAFAFA"
  })), _path480 || (_path480 = /*#__PURE__*/React.createElement("path", {
    d: "M253.155 133.123H251.704V134.574H253.155V133.123Z",
    fill: "#FAFAFA"
  })), _path481 || (_path481 = /*#__PURE__*/React.createElement("path", {
    d: "M253.155 135.557H251.704V137.009H253.155V135.557Z",
    fill: "#FAFAFA"
  })), _path482 || (_path482 = /*#__PURE__*/React.createElement("path", {
    d: "M253.155 137.991H251.704V139.442H253.155V137.991Z",
    fill: "#FAFAFA"
  })), _path483 || (_path483 = /*#__PURE__*/React.createElement("path", {
    d: "M253.155 140.425H251.704V141.877H253.155V140.425Z",
    fill: "#FAFAFA"
  })), _path484 || (_path484 = /*#__PURE__*/React.createElement("path", {
    d: "M253.155 142.858H251.704V144.31H253.155V142.858Z",
    fill: "#FAFAFA"
  })), _path485 || (_path485 = /*#__PURE__*/React.createElement("path", {
    d: "M253.155 145.292H251.704V146.744H253.155V145.292Z",
    fill: "#FAFAFA"
  })), _path486 || (_path486 = /*#__PURE__*/React.createElement("path", {
    d: "M253.155 147.726H251.704V149.178H253.155V147.726Z",
    fill: "#FAFAFA"
  })), _path487 || (_path487 = /*#__PURE__*/React.createElement("path", {
    d: "M253.155 150.16H251.704V151.612H253.155V150.16Z",
    fill: "#FAFAFA"
  })), _path488 || (_path488 = /*#__PURE__*/React.createElement("path", {
    d: "M253.155 157.462H251.704V158.913H253.155V157.462Z",
    fill: "#FAFAFA"
  })), _path489 || (_path489 = /*#__PURE__*/React.createElement("path", {
    d: "M253.155 159.896H251.704V161.347H253.155V159.896Z",
    fill: "#FAFAFA"
  })), _path490 || (_path490 = /*#__PURE__*/React.createElement("path", {
    d: "M253.155 164.763H251.704V166.215H253.155V164.763Z",
    fill: "#FAFAFA"
  })), _path491 || (_path491 = /*#__PURE__*/React.createElement("path", {
    d: "M253.155 167.197H251.704V168.648H253.155V167.197Z",
    fill: "#FAFAFA"
  })), _path492 || (_path492 = /*#__PURE__*/React.createElement("path", {
    d: "M253.155 169.631H251.704V171.082H253.155V169.631Z",
    fill: "#FAFAFA"
  })), _path493 || (_path493 = /*#__PURE__*/React.createElement("path", {
    d: "M253.155 172.065H251.704V173.516H253.155V172.065Z",
    fill: "#FAFAFA"
  })), _path494 || (_path494 = /*#__PURE__*/React.createElement("path", {
    d: "M250.849 120.953H249.397V122.405H250.849V120.953Z",
    fill: "#FAFAFA"
  })), _path495 || (_path495 = /*#__PURE__*/React.createElement("path", {
    d: "M250.849 123.387H249.397V124.838H250.849V123.387Z",
    fill: "#FAFAFA"
  })), _path496 || (_path496 = /*#__PURE__*/React.createElement("path", {
    d: "M250.849 125.821H249.397V127.272H250.849V125.821Z",
    fill: "#FAFAFA"
  })), _path497 || (_path497 = /*#__PURE__*/React.createElement("path", {
    d: "M250.849 128.255H249.397V129.706H250.849V128.255Z",
    fill: "#FAFAFA"
  })), _path498 || (_path498 = /*#__PURE__*/React.createElement("path", {
    d: "M250.849 130.689H249.397V132.14H250.849V130.689Z",
    fill: "#FAFAFA"
  })), _path499 || (_path499 = /*#__PURE__*/React.createElement("path", {
    d: "M250.849 133.123H249.397V134.574H250.849V133.123Z",
    fill: "#FAFAFA"
  })), _path500 || (_path500 = /*#__PURE__*/React.createElement("path", {
    d: "M250.849 135.557H249.397V137.009H250.849V135.557Z",
    fill: "#FAFAFA"
  })), _path501 || (_path501 = /*#__PURE__*/React.createElement("path", {
    d: "M250.849 137.991H249.397V139.442H250.849V137.991Z",
    fill: "#FAFAFA"
  })), _path502 || (_path502 = /*#__PURE__*/React.createElement("path", {
    d: "M250.849 140.425H249.397V141.877H250.849V140.425Z",
    fill: "#FAFAFA"
  })), _path503 || (_path503 = /*#__PURE__*/React.createElement("path", {
    d: "M250.849 142.858H249.397V144.31H250.849V142.858Z",
    fill: "#FAFAFA"
  })), _path504 || (_path504 = /*#__PURE__*/React.createElement("path", {
    d: "M250.849 145.292H249.397V146.744H250.849V145.292Z",
    fill: "#FAFAFA"
  })), _path505 || (_path505 = /*#__PURE__*/React.createElement("path", {
    d: "M250.849 147.726H249.397V149.178H250.849V147.726Z",
    fill: "#FAFAFA"
  })), _path506 || (_path506 = /*#__PURE__*/React.createElement("path", {
    d: "M250.849 150.16H249.397V151.612H250.849V150.16Z",
    fill: "#FAFAFA"
  })), _path507 || (_path507 = /*#__PURE__*/React.createElement("path", {
    d: "M250.849 152.594H249.397V154.045H250.849V152.594Z",
    fill: "#FAFAFA"
  })), _path508 || (_path508 = /*#__PURE__*/React.createElement("path", {
    d: "M250.849 157.462H249.397V158.913H250.849V157.462Z",
    fill: "#FAFAFA"
  })), _path509 || (_path509 = /*#__PURE__*/React.createElement("path", {
    d: "M250.849 162.329H249.397V163.781H250.849V162.329Z",
    fill: "#FAFAFA"
  })), _path510 || (_path510 = /*#__PURE__*/React.createElement("path", {
    d: "M250.849 164.763H249.397V166.215H250.849V164.763Z",
    fill: "#FAFAFA"
  })), _path511 || (_path511 = /*#__PURE__*/React.createElement("path", {
    d: "M250.849 167.197H249.397V168.648H250.849V167.197Z",
    fill: "#FAFAFA"
  })), _path512 || (_path512 = /*#__PURE__*/React.createElement("path", {
    d: "M250.849 169.631H249.397V171.082H250.849V169.631Z",
    fill: "#FAFAFA"
  })), _path513 || (_path513 = /*#__PURE__*/React.createElement("path", {
    d: "M250.849 172.065H249.397V173.516H250.849V172.065Z",
    fill: "#FAFAFA"
  })), _path514 || (_path514 = /*#__PURE__*/React.createElement("path", {
    d: "M264.855 134.831H263.403V136.282H264.855V134.831Z",
    fill: "#FAFAFA"
  })), _path515 || (_path515 = /*#__PURE__*/React.createElement("path", {
    d: "M264.855 137.265H263.403V138.716H264.855V137.265Z",
    fill: "#FAFAFA"
  })), _path516 || (_path516 = /*#__PURE__*/React.createElement("path", {
    d: "M264.855 139.698H263.403V141.15H264.855V139.698Z",
    fill: "#FAFAFA"
  })), _path517 || (_path517 = /*#__PURE__*/React.createElement("path", {
    d: "M264.855 142.132H263.403V143.584H264.855V142.132Z",
    fill: "#FAFAFA"
  })), _path518 || (_path518 = /*#__PURE__*/React.createElement("path", {
    d: "M264.855 144.566H263.403V146.018H264.855V144.566Z",
    fill: "#FAFAFA"
  })), _path519 || (_path519 = /*#__PURE__*/React.createElement("path", {
    d: "M264.855 147H263.403V148.452H264.855V147Z",
    fill: "#FAFAFA"
  })), _path520 || (_path520 = /*#__PURE__*/React.createElement("path", {
    d: "M264.855 154.302H263.403V155.753H264.855V154.302Z",
    fill: "#FAFAFA"
  })), _path521 || (_path521 = /*#__PURE__*/React.createElement("path", {
    d: "M264.855 156.736H263.403V158.187H264.855V156.736Z",
    fill: "#FAFAFA"
  })), _path522 || (_path522 = /*#__PURE__*/React.createElement("path", {
    d: "M264.855 159.169H263.403V160.621H264.855V159.169Z",
    fill: "#FAFAFA"
  })), _path523 || (_path523 = /*#__PURE__*/React.createElement("path", {
    d: "M264.855 161.604H263.403V163.056H264.855V161.604Z",
    fill: "#FAFAFA"
  })), _path524 || (_path524 = /*#__PURE__*/React.createElement("path", {
    d: "M264.855 164.038H263.403V165.49H264.855V164.038Z",
    fill: "#FAFAFA"
  })), _path525 || (_path525 = /*#__PURE__*/React.createElement("path", {
    d: "M264.855 166.472H263.403V167.923H264.855V166.472Z",
    fill: "#FAFAFA"
  })), _path526 || (_path526 = /*#__PURE__*/React.createElement("path", {
    d: "M264.855 168.906H263.403V170.357H264.855V168.906Z",
    fill: "#FAFAFA"
  })), _path527 || (_path527 = /*#__PURE__*/React.createElement("path", {
    d: "M262.549 134.831H261.098V136.282H262.549V134.831Z",
    fill: "#FAFAFA"
  })), _path528 || (_path528 = /*#__PURE__*/React.createElement("path", {
    d: "M262.549 137.265H261.098V138.716H262.549V137.265Z",
    fill: "#FAFAFA"
  })), _path529 || (_path529 = /*#__PURE__*/React.createElement("path", {
    d: "M262.549 139.698H261.098V141.15H262.549V139.698Z",
    fill: "#FAFAFA"
  })), _path530 || (_path530 = /*#__PURE__*/React.createElement("path", {
    d: "M262.549 142.132H261.098V143.584H262.549V142.132Z",
    fill: "#FAFAFA"
  })), _path531 || (_path531 = /*#__PURE__*/React.createElement("path", {
    d: "M262.549 144.566H261.098V146.018H262.549V144.566Z",
    fill: "#FAFAFA"
  })), _path532 || (_path532 = /*#__PURE__*/React.createElement("path", {
    d: "M262.549 147H261.098V148.452H262.549V147Z",
    fill: "#FAFAFA"
  })), _path533 || (_path533 = /*#__PURE__*/React.createElement("path", {
    d: "M262.549 154.302H261.098V155.753H262.549V154.302Z",
    fill: "#FAFAFA"
  })), _path534 || (_path534 = /*#__PURE__*/React.createElement("path", {
    d: "M262.549 156.736H261.098V158.187H262.549V156.736Z",
    fill: "#FAFAFA"
  })), _path535 || (_path535 = /*#__PURE__*/React.createElement("path", {
    d: "M262.549 159.169H261.098V160.621H262.549V159.169Z",
    fill: "#FAFAFA"
  })), _path536 || (_path536 = /*#__PURE__*/React.createElement("path", {
    d: "M262.549 161.604H261.098V163.056H262.549V161.604Z",
    fill: "#FAFAFA"
  })), _path537 || (_path537 = /*#__PURE__*/React.createElement("path", {
    d: "M262.549 164.038H261.098V165.49H262.549V164.038Z",
    fill: "#FAFAFA"
  })), _path538 || (_path538 = /*#__PURE__*/React.createElement("path", {
    d: "M262.549 166.472H261.098V167.923H262.549V166.472Z",
    fill: "#FAFAFA"
  })), _path539 || (_path539 = /*#__PURE__*/React.createElement("path", {
    d: "M262.549 171.34H261.098V172.791H262.549V171.34Z",
    fill: "#FAFAFA"
  })), _path540 || (_path540 = /*#__PURE__*/React.createElement("path", {
    d: "M208.717 55.2458H205.834V213.402H208.717V55.2458Z",
    fill: "#EBEBEB"
  })), _path541 || (_path541 = /*#__PURE__*/React.createElement("path", {
    d: "M254.557 55.2458H252.118V213.402H254.557V55.2458Z",
    fill: "#EBEBEB"
  })), _path542 || (_path542 = /*#__PURE__*/React.createElement("path", {
    d: "M300.396 55.2458H297.957V213.402H300.396V55.2458Z",
    fill: "#EBEBEB"
  })), _path543 || (_path543 = /*#__PURE__*/React.createElement("path", {
    d: "M118.951 43.6173C125.482 43.6173 130.777 38.3229 130.777 31.7919C130.777 25.261 125.482 19.9666 118.951 19.9666C112.42 19.9666 107.126 25.261 107.126 31.7919C107.126 38.3229 112.42 43.6173 118.951 43.6173Z",
    fill: "#E0E0E0"
  })), _path544 || (_path544 = /*#__PURE__*/React.createElement("path", {
    d: "M118.951 41.8461C124.504 41.8461 129.005 37.3446 129.005 31.7918C129.005 26.239 124.504 21.7375 118.951 21.7375C113.398 21.7375 108.897 26.239 108.897 31.7918C108.897 37.3446 113.398 41.8461 118.951 41.8461Z",
    fill: "#F0F0F0"
  })), _path545 || (_path545 = /*#__PURE__*/React.createElement("path", {
    d: "M119.426 24.8953V31.9239L124.083 29.2881",
    fill: "#F0F0F0"
  })), _path546 || (_path546 = /*#__PURE__*/React.createElement("path", {
    d: "M119.426 32.7585C119.281 32.7585 119.136 32.7209 119.005 32.645C118.749 32.4956 118.591 32.221 118.591 31.9238V24.8952C118.591 24.4345 118.965 24.0605 119.426 24.0605C119.887 24.0605 120.261 24.4345 120.261 24.8952V30.4932L123.673 28.5627C124.074 28.3348 124.583 28.4767 124.81 28.8773C125.037 29.2788 124.896 29.788 124.495 30.015L119.837 32.6508C119.709 32.7226 119.567 32.7585 119.426 32.7585Z",
    fill: "#E0E0E0"
  })), _path547 || (_path547 = /*#__PURE__*/React.createElement("path", {
    d: "M84.9548 115.921H66.175V273.658H84.9548V115.921Z",
    fill: "#E0E0E0"
  })), _path548 || (_path548 = /*#__PURE__*/React.createElement("path", {
    d: "M135.621 115.921H82.905V273.658H135.621V115.921Z",
    fill: "#EBEBEB"
  })), _path549 || (_path549 = /*#__PURE__*/React.createElement("path", {
    d: "M130.25 121.291H88.2744V163.267H130.25V121.291Z",
    fill: "#FAFAFA"
  })), _path550 || (_path550 = /*#__PURE__*/React.createElement("path", {
    d: "M120.618 145.987H97.9064C97.2696 145.987 96.7529 145.47 96.7529 144.833C96.7529 144.197 97.2696 143.68 97.9064 143.68H120.618C121.255 143.68 121.772 144.197 121.772 144.833C121.772 145.47 121.255 145.987 120.618 145.987Z",
    fill: "#E0E0E0"
  })), _path551 || (_path551 = /*#__PURE__*/React.createElement("path", {
    d: "M120.618 150.6H97.9064C97.2696 150.6 96.7529 150.084 96.7529 149.447C96.7529 148.81 97.2696 148.293 97.9064 148.293H120.618C121.255 148.293 121.772 148.81 121.772 149.447C121.772 150.085 121.255 150.6 120.618 150.6Z",
    fill: "#E0E0E0"
  })), _path552 || (_path552 = /*#__PURE__*/React.createElement("path", {
    d: "M120.618 155.214H97.9064C97.2696 155.214 96.7529 154.698 96.7529 154.061C96.7529 153.424 97.2696 152.907 97.9064 152.907H120.618C121.255 152.907 121.772 153.424 121.772 154.061C121.772 154.698 121.255 155.214 120.618 155.214Z",
    fill: "#E0E0E0"
  })), _path553 || (_path553 = /*#__PURE__*/React.createElement("path", {
    d: "M113.733 137.47H104.791L102.431 135.11V130.072L104.791 127.712H113.733L116.093 130.072V135.11L113.733 137.47Z",
    fill: "#EBEBEB"
  })), _path554 || (_path554 = /*#__PURE__*/React.createElement("path", {
    d: "M130.25 167.285H88.2744V209.261H130.25V167.285Z",
    fill: "#FAFAFA"
  })), _path555 || (_path555 = /*#__PURE__*/React.createElement("path", {
    d: "M120.618 191.982H97.9064C97.2696 191.982 96.7529 191.465 96.7529 190.828C96.7529 190.191 97.2696 189.675 97.9064 189.675H120.618C121.255 189.675 121.772 190.191 121.772 190.828C121.772 191.465 121.255 191.982 120.618 191.982Z",
    fill: "#E0E0E0"
  })), _path556 || (_path556 = /*#__PURE__*/React.createElement("path", {
    d: "M120.618 196.595H97.9064C97.2696 196.595 96.7529 196.078 96.7529 195.441C96.7529 194.804 97.2696 194.288 97.9064 194.288H120.618C121.255 194.288 121.772 194.804 121.772 195.441C121.772 196.078 121.255 196.595 120.618 196.595Z",
    fill: "#E0E0E0"
  })), _path557 || (_path557 = /*#__PURE__*/React.createElement("path", {
    d: "M120.618 201.208H97.9064C97.2696 201.208 96.7529 200.691 96.7529 200.054C96.7529 199.418 97.2696 198.901 97.9064 198.901H120.618C121.255 198.901 121.772 199.418 121.772 200.054C121.772 200.691 121.255 201.208 120.618 201.208Z",
    fill: "#E0E0E0"
  })), _path558 || (_path558 = /*#__PURE__*/React.createElement("path", {
    d: "M113.733 183.464H104.791L102.431 181.104V176.066L104.791 173.705H113.733L116.093 176.066V181.104L113.733 183.464Z",
    fill: "#EBEBEB"
  })), _path559 || (_path559 = /*#__PURE__*/React.createElement("path", {
    d: "M130.25 213.28H88.2744V255.255H130.25V213.28Z",
    fill: "#FAFAFA"
  })), _path560 || (_path560 = /*#__PURE__*/React.createElement("path", {
    d: "M120.618 237.975H97.9064C97.2696 237.975 96.7529 237.459 96.7529 236.822C96.7529 236.185 97.2696 235.668 97.9064 235.668H120.618C121.255 235.668 121.772 236.185 121.772 236.822C121.772 237.459 121.255 237.975 120.618 237.975Z",
    fill: "#E0E0E0"
  })), _path561 || (_path561 = /*#__PURE__*/React.createElement("path", {
    d: "M120.618 242.588H97.9064C97.2696 242.588 96.7529 242.072 96.7529 241.435C96.7529 240.798 97.2696 240.281 97.9064 240.281H120.618C121.255 240.281 121.772 240.798 121.772 241.435C121.772 242.073 121.255 242.588 120.618 242.588Z",
    fill: "#E0E0E0"
  })), _path562 || (_path562 = /*#__PURE__*/React.createElement("path", {
    d: "M120.618 247.202H97.9064C97.2696 247.202 96.7529 246.686 96.7529 246.049C96.7529 245.412 97.2696 244.895 97.9064 244.895H120.618C121.255 244.895 121.772 245.412 121.772 246.049C121.772 246.686 121.255 247.202 120.618 247.202Z",
    fill: "#E0E0E0"
  })), _path563 || (_path563 = /*#__PURE__*/React.createElement("path", {
    d: "M113.733 229.458H104.791L102.431 227.098V222.06L104.791 219.7H113.733L116.093 222.06V227.098L113.733 229.458Z",
    fill: "#EBEBEB"
  })), _path564 || (_path564 = /*#__PURE__*/React.createElement("path", {
    d: "M209.328 311C298.704 311 371.158 306.769 371.158 301.549C371.158 296.33 298.704 292.098 209.328 292.098C119.951 292.098 47.4971 296.33 47.4971 301.549C47.4971 306.769 119.951 311 209.328 311Z",
    fill: "#F5F5F5"
  })), _path565 || (_path565 = /*#__PURE__*/React.createElement("path", {
    d: "M322.069 224.919C322.245 226.146 318.918 226.954 316.203 227.406C316.425 229.634 317.907 231.885 319.954 233.988C322.529 232.537 326.206 230.619 326.884 231.088C327.623 231.599 323.859 234.033 321.504 235.465C323.16 236.934 325.025 238.304 326.837 239.504C327.991 238.426 329.343 237.479 330.148 237.991C330.983 238.523 330.757 240.191 330.345 241.68C333.147 243.313 335.244 244.307 335.244 244.307C335.244 244.307 336.42 240.742 337.116 236.353C336.975 236.074 336.834 235.792 336.705 235.494C336.253 234.45 336.693 234.006 337.439 233.859C337.631 231.937 337.687 229.962 337.485 228.128C334.314 227.463 330.458 226.232 331.902 224.33C332.774 223.183 334.368 223.053 336.027 223.341C335.795 222.959 335.539 222.598 335.244 222.274C329.474 215.916 325.448 222.274 325.448 222.274C322.094 219.48 317.384 220.236 316.365 224.603C318.249 224.121 321.853 223.403 322.069 224.919Z",
    fill: "#407BFF"
  })), _path566 || (_path566 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M322.069 224.919C322.245 226.146 318.918 226.954 316.203 227.406C316.425 229.634 317.907 231.885 319.954 233.988C322.529 232.537 326.206 230.619 326.884 231.088C327.623 231.599 323.859 234.033 321.504 235.465C323.16 236.934 325.025 238.304 326.837 239.504C327.991 238.426 329.343 237.479 330.148 237.991C330.983 238.523 330.757 240.191 330.345 241.68C333.147 243.313 335.244 244.307 335.244 244.307C335.244 244.307 336.42 240.742 337.116 236.353C336.975 236.074 336.834 235.792 336.705 235.494C336.253 234.45 336.693 234.006 337.439 233.859C337.631 231.937 337.687 229.962 337.485 228.128C334.314 227.463 330.458 226.232 331.902 224.33C332.774 223.183 334.368 223.053 336.027 223.341C335.795 222.959 335.539 222.598 335.244 222.274C329.474 215.916 325.448 222.274 325.448 222.274C322.094 219.48 317.384 220.236 316.365 224.603C318.249 224.121 321.853 223.403 322.069 224.919Z",
    fill: "white"
  })), _path567 || (_path567 = /*#__PURE__*/React.createElement("path", {
    d: "M329.27 271.648L328.438 271.58C328.474 271.15 331.855 228.574 322.3 224.56C321.274 224.129 320.326 224.153 319.404 224.633C315.952 226.428 314.296 233.882 314.281 233.958L313.465 233.781C313.535 233.458 315.22 225.87 319.018 223.892C320.159 223.299 321.372 223.265 322.624 223.791C332.731 228.036 329.416 269.869 329.27 271.648Z",
    fill: "#407BFF"
  })), _path568 || (_path568 = /*#__PURE__*/React.createElement("path", {
    d: "M330.475 270.726C330.305 268.81 326.406 223.761 333.698 218.98C335.447 217.834 337.005 217.588 338.329 218.259C341.776 219.997 342.228 227.365 342.246 227.677L341.413 227.725C341.409 227.653 340.971 220.525 337.953 219.004C336.915 218.482 335.637 218.707 334.155 219.678C327.276 224.189 331.265 270.189 331.306 270.653L330.475 270.726Z",
    fill: "#407BFF"
  })), _path569 || (_path569 = /*#__PURE__*/React.createElement("path", {
    d: "M331.57 274.367C331.516 272.9 330.315 238.418 336.956 235.399C338.269 234.802 339.597 234.792 340.905 235.367C345.462 237.372 348.277 245.864 348.395 246.225L347.601 246.484C347.573 246.399 344.785 237.985 340.569 236.131C339.473 235.651 338.403 235.658 337.301 236.159C332.209 238.473 332.039 264.502 332.404 274.336L331.57 274.367Z",
    fill: "#407BFF"
  })), _path570 || (_path570 = /*#__PURE__*/React.createElement("path", {
    d: "M329.881 272.79L329.052 272.695C330.222 262.432 332.459 235.085 328.804 231.822C328.259 231.335 327.771 231.184 327.309 231.36C324.859 232.3 323.367 241.194 322.999 244.543L322.17 244.452C322.311 243.168 323.646 231.871 327.009 230.581C327.779 230.286 328.569 230.493 329.359 231.2C334.084 235.415 330.055 271.265 329.881 272.79Z",
    fill: "#407BFF"
  })), _path571 || (_path571 = /*#__PURE__*/React.createElement("path", {
    d: "M315.952 253.334H345.939L343.435 286.924H318.456L315.952 253.334Z",
    fill: "#263238"
  })), _path572 || (_path572 = /*#__PURE__*/React.createElement("path", {
    d: "M320.037 241.008C319.724 241.825 317.395 241.182 315.567 240.53C314.94 241.98 315.082 243.876 315.624 245.875C317.709 245.864 320.634 245.941 320.891 246.462C321.171 247.031 318.016 247.242 316.073 247.317C316.591 248.791 317.271 250.275 317.977 251.636C319.059 251.367 320.217 251.246 320.538 251.838C320.871 252.452 320.16 253.404 319.394 254.181C320.562 256.148 321.515 257.48 321.515 257.48C321.515 257.48 323.463 255.685 325.397 253.217C325.405 252.997 325.415 252.775 325.437 252.547C325.517 251.748 325.941 251.624 326.451 251.79C327.229 250.671 327.94 249.472 328.444 248.272C326.716 246.774 324.76 244.694 326.303 244.016C327.234 243.607 328.261 244.073 329.186 244.82C329.174 244.504 329.139 244.194 329.069 243.893C327.69 237.993 323.027 240.534 323.027 240.534C321.917 237.661 318.753 236.512 316.627 238.857C317.955 239.206 320.424 239.999 320.037 241.008Z",
    fill: "#407BFF"
  })), _path573 || (_path573 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M320.037 241.008C319.724 241.825 317.395 241.182 315.567 240.53C314.94 241.98 315.082 243.876 315.624 245.875C317.709 245.864 320.634 245.941 320.891 246.462C321.171 247.031 318.016 247.242 316.073 247.317C316.591 248.791 317.271 250.275 317.977 251.636C319.059 251.367 320.217 251.246 320.538 251.838C320.871 252.452 320.16 253.404 319.394 254.181C320.562 256.148 321.515 257.48 321.515 257.48C321.515 257.48 323.463 255.685 325.397 253.217C325.405 252.997 325.415 252.775 325.437 252.547C325.517 251.748 325.941 251.624 326.451 251.79C327.229 250.671 327.94 249.472 328.444 248.272C326.716 246.774 324.76 244.694 326.303 244.016C327.234 243.607 328.261 244.073 329.186 244.82C329.174 244.504 329.139 244.194 329.069 243.893C327.69 237.993 323.027 240.534 323.027 240.534C321.917 237.661 318.753 236.512 316.627 238.857C317.955 239.206 320.424 239.999 320.037 241.008Z",
    fill: "white"
  })), _path574 || (_path574 = /*#__PURE__*/React.createElement("path", {
    d: "M342.303 244.996C341.357 245.066 340.449 245.283 339.562 245.572C339.331 244.939 339.18 244.279 339.158 243.588C338.968 237.54 343.297 240.09 345.585 238.313C346.726 237.427 348.123 236.858 349.412 237.113C349.219 237.446 349.042 237.791 348.895 238.148C348.655 238.727 349.032 239.331 349.627 239.442C350.185 239.546 350.812 239.498 351.325 239.241C351.485 239.161 351.62 239.044 351.762 238.939C352.081 239.478 352.364 240.14 352.592 240.961C352.825 241.801 352.945 242.673 352.984 243.547C352.643 243.623 352.305 243.714 351.972 243.833C351.452 244.017 351.174 244.849 351.593 245.27C351.961 245.64 352.383 245.934 352.841 246.146C352.692 247.142 352.414 248.086 352.08 248.98C351.977 248.996 351.874 249.008 351.772 249.028C351.551 249.07 351.334 249.128 351.119 249.189C350.996 249.224 350.873 249.267 350.757 249.322C350.457 249.464 350.238 249.72 350.192 250.055C350.145 250.385 350.283 250.726 350.548 250.928C350.689 251.036 350.844 251.12 350.998 251.205C350.309 252.296 349.493 253.161 348.603 253.623C348.603 253.623 347.499 253.141 346.055 252.276C346.235 252.034 346.417 251.792 346.584 251.542C346.783 251.247 346.871 250.944 346.841 250.592C346.812 250.251 346.605 249.953 346.351 249.739C346.105 249.532 345.713 249.442 345.401 249.482C345.095 249.521 344.724 249.709 344.548 249.972C344.347 250.27 344.126 250.554 343.908 250.838C342.803 250.005 341.703 248.999 340.836 247.856C340.869 247.846 340.905 247.836 340.928 247.829C341.486 247.683 342.057 247.589 342.632 247.546C343.351 247.493 343.798 246.77 343.742 246.107C343.682 245.387 342.972 244.946 342.303 244.996Z",
    fill: "#407BFF"
  })), _path575 || (_path575 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M342.303 244.996C341.357 245.066 340.449 245.283 339.562 245.572C339.331 244.939 339.18 244.279 339.158 243.588C338.968 237.54 343.297 240.09 345.585 238.313C346.726 237.427 348.123 236.858 349.412 237.113C349.219 237.446 349.042 237.791 348.895 238.148C348.655 238.727 349.032 239.331 349.627 239.442C350.185 239.546 350.812 239.498 351.325 239.241C351.485 239.161 351.62 239.044 351.762 238.939C352.081 239.478 352.364 240.14 352.592 240.961C352.825 241.801 352.945 242.673 352.984 243.547C352.643 243.623 352.305 243.714 351.972 243.833C351.452 244.017 351.174 244.849 351.593 245.27C351.961 245.64 352.383 245.934 352.841 246.146C352.692 247.142 352.414 248.086 352.08 248.98C351.977 248.996 351.874 249.008 351.772 249.028C351.551 249.07 351.334 249.128 351.119 249.189C350.996 249.224 350.873 249.267 350.757 249.322C350.457 249.464 350.238 249.72 350.192 250.055C350.145 250.385 350.283 250.726 350.548 250.928C350.689 251.036 350.844 251.12 350.998 251.205C350.309 252.296 349.493 253.161 348.603 253.623C348.603 253.623 347.499 253.141 346.055 252.276C346.235 252.034 346.417 251.792 346.584 251.542C346.783 251.247 346.871 250.944 346.841 250.592C346.812 250.251 346.605 249.953 346.351 249.739C346.105 249.532 345.713 249.442 345.401 249.482C345.095 249.521 344.724 249.709 344.548 249.972C344.347 250.27 344.126 250.554 343.908 250.838C342.803 250.005 341.703 248.999 340.836 247.856C340.869 247.846 340.905 247.836 340.928 247.829C341.486 247.683 342.057 247.589 342.632 247.546C343.351 247.493 343.798 246.77 343.742 246.107C343.682 245.387 342.972 244.946 342.303 244.996Z",
    fill: "white"
  })), _path576 || (_path576 = /*#__PURE__*/React.createElement("path", {
    d: "M344.033 224.144C344.56 223.766 345.132 223.482 345.725 223.245C345.568 222.811 345.358 222.398 345.067 222.025C342.513 218.765 341.357 222.004 339.375 222.075C338.387 222.11 337.403 222.423 336.838 223.124C337.086 223.214 337.329 223.317 337.564 223.441C337.944 223.64 338.011 224.123 337.747 224.442C337.5 224.741 337.149 224.992 336.766 225.081C336.647 225.109 336.525 225.107 336.404 225.113C336.472 225.537 336.614 226.009 336.855 226.541C337.102 227.085 337.421 227.595 337.785 228.071C337.997 227.961 338.215 227.861 338.442 227.777C338.797 227.646 339.308 227.961 339.272 228.366C339.241 228.722 339.148 229.061 339 229.374C339.516 229.831 340.076 230.206 340.645 230.529C340.706 230.492 340.765 230.453 340.827 230.419C340.962 230.344 341.101 230.279 341.241 230.217C341.322 230.181 341.404 230.149 341.49 230.127C341.71 230.07 341.937 230.109 342.109 230.264C342.278 230.417 342.356 230.656 342.305 230.879C342.278 230.998 342.234 231.11 342.19 231.222C343.031 231.493 343.838 231.59 344.509 231.441C344.509 231.441 344.877 230.704 345.257 229.616C345.056 229.568 344.855 229.52 344.657 229.462C344.423 229.394 344.245 229.274 344.105 229.076C343.97 228.884 343.948 228.637 343.988 228.412C344.027 228.196 344.193 227.976 344.375 227.86C344.553 227.747 344.83 227.683 345.038 227.743C345.275 227.812 345.515 227.864 345.754 227.917C345.969 226.995 346.106 225.984 346.059 225.002C346.037 225.013 346.014 225.023 345.999 225.028C345.642 225.197 345.3 225.397 344.979 225.628C344.578 225.915 344.026 225.731 343.764 225.358C343.48 224.956 343.659 224.412 344.033 224.144Z",
    fill: "#407BFF"
  })), _path577 || (_path577 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M344.033 224.144C344.56 223.766 345.132 223.482 345.725 223.245C345.568 222.811 345.358 222.398 345.067 222.025C342.513 218.765 341.357 222.004 339.375 222.075C338.387 222.11 337.403 222.423 336.838 223.124C337.086 223.214 337.329 223.317 337.564 223.441C337.944 223.64 338.011 224.123 337.747 224.442C337.5 224.741 337.149 224.992 336.766 225.081C336.647 225.109 336.525 225.107 336.404 225.113C336.472 225.537 336.614 226.009 336.855 226.541C337.102 227.085 337.421 227.595 337.785 228.071C337.997 227.961 338.215 227.861 338.442 227.777C338.797 227.646 339.308 227.961 339.272 228.366C339.241 228.722 339.148 229.061 339 229.374C339.516 229.831 340.076 230.206 340.645 230.529C340.706 230.492 340.765 230.453 340.827 230.419C340.962 230.344 341.101 230.279 341.241 230.217C341.322 230.181 341.404 230.149 341.49 230.127C341.71 230.07 341.937 230.109 342.109 230.264C342.278 230.417 342.356 230.656 342.305 230.879C342.278 230.998 342.234 231.11 342.19 231.222C343.031 231.493 343.838 231.59 344.509 231.441C344.509 231.441 344.877 230.704 345.257 229.616C345.056 229.568 344.855 229.52 344.657 229.462C344.423 229.394 344.245 229.274 344.105 229.076C343.97 228.884 343.948 228.637 343.988 228.412C344.027 228.196 344.193 227.976 344.375 227.86C344.553 227.747 344.83 227.683 345.038 227.743C345.275 227.812 345.515 227.864 345.754 227.917C345.969 226.995 346.106 225.984 346.059 225.002C346.037 225.013 346.014 225.023 345.999 225.028C345.642 225.197 345.3 225.397 344.979 225.628C344.578 225.915 344.026 225.731 343.764 225.358C343.48 224.956 343.659 224.412 344.033 224.144Z",
    fill: "white"
  })), _path578 || (_path578 = /*#__PURE__*/React.createElement("path", {
    d: "M319.601 230.197C319.425 231.424 322.753 232.232 325.467 232.684C325.245 234.912 323.763 237.164 321.716 239.267C319.141 237.816 315.464 235.898 314.786 236.366C314.047 236.878 317.811 239.312 320.165 240.743C318.509 242.213 316.644 243.583 314.832 244.783C313.678 243.704 312.327 242.758 311.521 243.27C310.686 243.801 310.912 245.47 311.324 246.959C308.523 248.592 306.425 249.585 306.425 249.585C306.425 249.585 305.249 246.021 304.553 241.631C304.694 241.352 304.835 241.07 304.964 240.772C305.416 239.728 304.976 239.284 304.23 239.137C304.038 237.216 303.982 235.24 304.184 233.406C307.355 232.741 311.211 231.51 309.767 229.609C308.895 228.462 307.301 228.333 305.642 228.62C305.874 228.237 306.131 227.877 306.425 227.553C312.195 221.195 316.221 227.553 316.221 227.553C319.575 224.758 324.285 225.515 325.304 229.882C323.421 229.4 319.817 228.681 319.601 230.197Z",
    fill: "#407BFF"
  })), _path579 || (_path579 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M319.601 230.197C319.425 231.424 322.753 232.232 325.467 232.684C325.245 234.912 323.763 237.164 321.716 239.267C319.141 237.816 315.464 235.898 314.786 236.366C314.047 236.878 317.811 239.312 320.165 240.743C318.509 242.213 316.644 243.583 314.832 244.783C313.678 243.704 312.327 242.758 311.521 243.27C310.686 243.801 310.912 245.47 311.324 246.959C308.523 248.592 306.425 249.585 306.425 249.585C306.425 249.585 305.249 246.021 304.553 241.631C304.694 241.352 304.835 241.07 304.964 240.772C305.416 239.728 304.976 239.284 304.23 239.137C304.038 237.216 303.982 235.24 304.184 233.406C307.355 232.741 311.211 231.51 309.767 229.609C308.895 228.462 307.301 228.333 305.642 228.62C305.874 228.237 306.131 227.877 306.425 227.553C312.195 221.195 316.221 227.553 316.221 227.553C319.575 224.758 324.285 225.515 325.304 229.882C323.421 229.4 319.817 228.681 319.601 230.197Z",
    fill: "white"
  })), _path580 || (_path580 = /*#__PURE__*/React.createElement("path", {
    d: "M159.312 298.898L138.274 291.15L117.006 298.903C116.272 299.171 115.496 298.627 115.496 297.846C115.496 297.408 115.75 297.01 116.147 296.825L138.274 286.559L160.178 296.824C160.573 297.01 160.825 297.406 160.825 297.843C160.826 298.625 160.047 299.168 159.312 298.898Z",
    fill: "#263238"
  })), _path581 || (_path581 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M159.312 298.898L138.274 291.15L117.006 298.903C116.272 299.171 115.496 298.627 115.496 297.846C115.496 297.408 115.75 297.01 116.147 296.825L138.274 286.559L160.178 296.824C160.573 297.01 160.825 297.406 160.825 297.843C160.826 298.625 160.047 299.168 159.312 298.898Z",
    fill: "white"
  })), _path582 || (_path582 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M133.317 292.958L138.274 291.15L143.005 292.892V288.776L138.274 286.559L133.317 288.859V292.958Z",
    fill: "black"
  })), _path583 || (_path583 = /*#__PURE__*/React.createElement("path", {
    d: "M138.161 299.077C137.198 299.077 136.392 298.345 136.301 297.386L135.707 291.149V239.386H140.614V291.149L140.02 297.386C139.93 298.345 139.124 299.077 138.161 299.077Z",
    fill: "#263238"
  })), _path584 || (_path584 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M138.161 299.077C137.198 299.077 136.392 298.345 136.301 297.386L135.707 291.149V239.386H140.614V291.149L140.02 297.386C139.93 298.345 139.124 299.077 138.161 299.077Z",
    fill: "white"
  })), _path585 || (_path585 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M140.614 239.387H135.708V245.415H140.614V239.387Z",
    fill: "black"
  })), _path586 || (_path586 = /*#__PURE__*/React.createElement("path", {
    d: "M127.156 186.058C127.858 186.045 128.562 186.358 129.032 187.139C138.02 202.084 141.212 220.05 138.111 237.19C137.917 238.265 137.182 238.765 136.365 238.821C135.005 238.913 110.786 238.827 109.908 238.826C108.588 238.823 107.137 237.7 107.447 235.986C110.328 220.058 107.156 203.279 98.8242 189.424C97.7892 187.702 99.3158 186.086 100.859 186.057C101.561 186.044 125.612 186.088 127.156 186.058Z",
    fill: "#407BFF"
  })), _path587 || (_path587 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M127.156 186.058C127.858 186.045 128.562 186.358 129.032 187.139C138.02 202.084 141.212 220.05 138.111 237.19C137.917 238.265 137.182 238.765 136.365 238.821C135.005 238.913 110.786 238.827 109.908 238.826C108.588 238.823 107.137 237.7 107.447 235.986C110.328 220.058 107.156 203.279 98.8242 189.424C97.7892 187.702 99.3158 186.086 100.859 186.057C101.561 186.044 125.612 186.088 127.156 186.058Z",
    fill: "black"
  })), _path588 || (_path588 = /*#__PURE__*/React.createElement("path", {
    d: "M107.447 235.987C110.328 220.059 107.156 203.28 98.8243 189.425C97.3186 186.92 101.233 184.641 102.735 187.139C111.723 202.084 114.916 220.05 111.815 237.191C111.297 240.055 106.93 238.842 107.447 235.987Z",
    fill: "#407BFF"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M107.447 235.987C110.328 220.059 107.156 203.28 98.8243 189.425C97.3186 186.92 101.233 184.641 102.735 187.139C111.723 202.084 114.916 220.05 111.815 237.191C111.297 240.055 106.93 238.842 107.447 235.987Z",
    fill: "white"
  }))), _path589 || (_path589 = /*#__PURE__*/React.createElement("path", {
    d: "M182.968 234.675C177.417 233.26 171.712 232.481 165.992 232.338C160.097 232.19 138.03 232.315 132.79 232.313C126.412 232.311 120.033 233.097 113.844 234.675C109.953 235.668 111.153 241.282 114.667 241.347C114.977 241.353 181.683 241.333 181.928 241.343C185.604 241.51 186.945 235.69 182.968 234.675Z",
    fill: "#407BFF"
  })), _path590 || (_path590 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M182.968 234.675C177.417 233.26 171.712 232.481 165.992 232.338C160.097 232.19 138.03 232.315 132.79 232.313C126.412 232.311 120.033 233.097 113.844 234.675C109.953 235.668 111.153 241.282 114.667 241.347C114.977 241.353 181.683 241.333 181.928 241.343C185.604 241.51 186.945 235.69 182.968 234.675Z",
    fill: "black"
  })), _path591 || (_path591 = /*#__PURE__*/React.createElement("path", {
    d: "M115.65 241.227C126.855 238.369 138.725 238.369 149.93 241.227C154.168 242.308 155.977 235.756 151.736 234.675C139.359 231.518 126.221 231.518 113.844 234.675C109.61 235.755 111.404 242.31 115.65 241.227Z",
    fill: "#407BFF"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M115.65 241.227C126.855 238.369 138.725 238.369 149.93 241.227C154.168 242.308 155.977 235.756 151.736 234.675C139.359 231.518 126.221 231.518 113.844 234.675C109.61 235.755 111.404 242.31 115.65 241.227Z",
    fill: "white"
  }))), _path592 || (_path592 = /*#__PURE__*/React.createElement("path", {
    d: "M156.959 208.316H127.081V220.291H156.959V208.316Z",
    fill: "#263238"
  })), _path593 || (_path593 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M156.959 208.316H127.081V220.291H156.959V208.316Z",
    fill: "white"
  })), _path594 || (_path594 = /*#__PURE__*/React.createElement("path", {
    d: "M173.047 271.921L169.116 289.039L173.995 290.929L181.024 273.711L173.047 271.921Z",
    fill: "#B55B52"
  })), _path595 || (_path595 = /*#__PURE__*/React.createElement("path", {
    d: "M173.711 289.81L169.278 287.438C169.085 287.335 168.846 287.378 168.702 287.544L165.537 291.207C165.255 291.53 165.286 292.021 165.609 292.304C165.651 292.341 165.696 292.373 165.744 292.4C167.605 293.36 169.298 294.142 171.592 295.381C174.301 296.841 173.439 296.794 176.599 298.554C178.505 299.613 180.03 297.62 179.274 297.075C175.803 294.601 175.341 292.886 174.622 290.78C174.447 290.356 174.124 290.011 173.711 289.81Z",
    fill: "#263238"
  })), _path596 || (_path596 = /*#__PURE__*/React.createElement("path", {
    d: "M133.487 218.82L157.456 217.5C157.456 217.5 197.279 223.728 196.712 234.863C196.146 245.998 179.914 281.103 179.914 281.103L170.411 278.461C170.411 278.461 177.649 243.167 182.367 237.317C182.367 237.317 152.628 233.828 145.187 231.844C141.093 230.751 131.221 232.596 133.487 218.82Z",
    fill: "#263238"
  })), _path597 || (_path597 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M133.487 218.82L157.456 217.5C157.456 217.5 197.279 223.728 196.712 234.863C196.146 245.998 179.914 281.103 179.914 281.103L170.411 278.461C170.411 278.461 177.649 243.167 182.367 237.317C182.367 237.317 152.628 233.828 145.187 231.844C141.093 230.751 131.221 232.596 133.487 218.82Z",
    fill: "white"
  })), _path598 || (_path598 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M178.345 236.832C178.453 234.585 178.23 231.085 176.518 227.22C174.303 222.218 156.074 219.219 147.353 218.057L133.488 218.821C131.223 232.597 141.094 230.752 145.189 231.844C150.933 233.376 169.964 235.804 178.345 236.832Z",
    fill: "black"
  })), _path599 || (_path599 = /*#__PURE__*/React.createElement("path", {
    d: "M156.764 276.636L156.134 294.188L161.419 294.44L164.936 276.887L156.764 276.636Z",
    fill: "#B55B52"
  })), _path600 || (_path600 = /*#__PURE__*/React.createElement("path", {
    d: "M161.039 292.844L155.92 292.953C155.698 292.957 155.507 293.115 155.462 293.333L154.482 298.164C154.391 298.593 154.665 299.013 155.093 299.103C155.148 299.114 155.204 299.12 155.26 299.119C157.391 299.043 159.285 298.892 161.94 298.847C165.072 298.791 164.285 299.18 167.968 299.165C170.187 299.154 170.547 296.625 169.605 296.518C165.289 296.054 164.022 294.762 162.333 293.252C161.966 292.961 161.506 292.817 161.039 292.844Z",
    fill: "#263238"
  })), _path601 || (_path601 = /*#__PURE__*/React.createElement("path", {
    d: "M169.656 276.385L181.614 279.719L179.427 284.316L168.528 281.607L169.656 276.385Z",
    fill: "#263238"
  })), _path602 || (_path602 = /*#__PURE__*/React.createElement("path", {
    d: "M139.904 218.821C139.904 218.821 171.989 219.954 173.876 229.768C175.763 239.582 165.005 283.556 165.005 283.556H155.38C155.38 283.556 156.512 244.111 159.721 235.807C159.721 235.807 133.298 239.959 126.315 233.962C121.324 229.676 127.259 218.819 127.259 218.819L139.904 218.821Z",
    fill: "#263238"
  })), _path603 || (_path603 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M139.904 218.821C139.904 218.821 171.989 219.954 173.876 229.768C175.763 239.582 165.005 283.556 165.005 283.556H155.38C155.38 283.556 156.512 244.111 159.721 235.807C159.721 235.807 133.298 239.959 126.315 233.962C121.324 229.676 127.259 218.819 127.259 218.819L139.904 218.821Z",
    fill: "white"
  })), _path604 || (_path604 = /*#__PURE__*/React.createElement("path", {
    d: "M154.436 281.103L166.515 281.669L165.382 286.482L154.436 285.916V281.103Z",
    fill: "#263238"
  })), _path605 || (_path605 = /*#__PURE__*/React.createElement("path", {
    d: "M182.526 181.605L187.671 179.685L183.288 175.455C183.288 175.455 178.801 177.446 179.924 179.714L182.526 181.605Z",
    fill: "#B55B52"
  })), _path606 || (_path606 = /*#__PURE__*/React.createElement("path", {
    d: "M191.034 175.409L186.032 173.052L183.289 175.454L187.671 179.684L191.034 175.409Z",
    fill: "#B55B52"
  })), _path607 || (_path607 = /*#__PURE__*/React.createElement("path", {
    d: "M175.994 181.831L179.022 178.53L183.073 181.981L179.79 185.858L175.994 181.831Z",
    fill: "#407BFF"
  })), _path608 || (_path608 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M175.994 181.831L179.022 178.53L183.073 181.981L179.79 185.858L175.994 181.831Z",
    fill: "white"
  })), _path609 || (_path609 = /*#__PURE__*/React.createElement("path", {
    d: "M155.468 161.527C155.468 161.527 158.628 165.122 163.194 176.877C167.758 188.631 172.818 185.203 178.374 178.866L182.938 183.021C182.938 183.021 174.404 193.655 169.033 193.655C163.054 193.655 157.25 184.386 156.082 177.911C154.915 171.436 155.468 161.527 155.468 161.527Z",
    fill: "#263238"
  })), _path610 || (_path610 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M156.586 168.326L154.887 166.907L154.093 171.429C154.205 172.741 154.358 174.02 154.569 175.187C155.235 178.878 157.734 183.72 160.421 187.749C159.441 178.798 156.586 168.326 156.586 168.326Z",
    fill: "black"
  })), _path611 || (_path611 = /*#__PURE__*/React.createElement("path", {
    d: "M124.129 196.527L124.603 221.013L142.632 221.621C144.987 221.646 145.533 220.058 146.026 218.278L146.912 215.077L147.698 217.972C148.176 219.735 150.642 220.028 152.431 219.662L160.281 217.719L158.48 193.602C158.48 193.602 159.691 175.441 156.852 163.813C156.311 161.599 154.293 160.057 152.077 159.528C147.033 158.323 136.197 156.811 123.893 161.664C122.75 162.114 122.049 163.281 122.2 164.501L124.129 196.527Z",
    fill: "#263238"
  })), _path612 || (_path612 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M146.486 186.152C146.486 186.566 146.15 186.902 145.736 186.902C145.322 186.902 144.987 186.566 144.987 186.152C144.987 185.738 145.322 185.403 145.736 185.403C146.15 185.403 146.486 185.738 146.486 186.152Z",
    fill: "black"
  })), _path613 || (_path613 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M147.222 196.527C147.222 196.941 146.887 197.277 146.473 197.277C146.059 197.277 145.723 196.941 145.723 196.527C145.723 196.113 146.059 195.778 146.473 195.778C146.887 195.778 147.222 196.113 147.222 196.527Z",
    fill: "black"
  })), _path614 || (_path614 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M147.525 206.775C147.525 207.189 147.189 207.524 146.775 207.524C146.361 207.524 146.026 207.189 146.026 206.775C146.026 206.361 146.361 206.025 146.775 206.025C147.189 206.025 147.525 206.361 147.525 206.775Z",
    fill: "black"
  })), _path615 || (_path615 = /*#__PURE__*/React.createElement("path", {
    d: "M134.429 158.004C134.429 158.004 138.412 156.276 143.4 157.381L145.241 158.431L145.887 160.481L143.555 162.309L138.049 162.869L133.498 160.987L133.75 158.965L134.429 158.004Z",
    fill: "#263238"
  })), _path616 || (_path616 = /*#__PURE__*/React.createElement("path", {
    d: "M144.506 159.063C142.681 158.577 141.388 155.396 142.891 153.351L134.912 147.173C136.075 158.317 135.505 156.29 133.846 159.494C133.846 159.494 134.996 163.209 141.427 162.054C145.603 161.304 144.506 159.063 144.506 159.063Z",
    fill: "#B55B52"
  })), _path617 || (_path617 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M142.891 153.351L134.858 147.396C135.064 148.967 135.086 148.978 135.197 150.113C136.046 151.837 137.764 156.231 142.292 156.362C142.094 155.571 142.319 153.853 142.891 153.351Z",
    fill: "black"
  })), _path618 || (_path618 = /*#__PURE__*/React.createElement("path", {
    d: "M133.962 164.948L136.153 172.084L141.246 179.444L145.424 183.789L146.989 177.418L146.486 164.121L146.406 161.257L145.235 159.61L143.378 161.24L141.795 161.851L139.478 161.87L133.391 160.019L133.962 164.948Z",
    fill: "#407BFF"
  })), _path619 || (_path619 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M133.962 164.948L136.153 172.084L141.246 179.444L145.424 183.789L146.989 177.418L146.486 164.121L146.406 161.257L145.235 159.61L143.378 161.24L141.795 161.851L139.478 161.87L133.391 160.019L133.962 164.948Z",
    fill: "#407BFF"
  })), _path620 || (_path620 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M133.962 164.948L136.153 172.084L141.246 179.444L145.424 183.789L146.989 177.418L146.486 164.121L146.406 161.257L145.235 159.61L143.378 161.24L141.795 161.851L139.478 161.87L133.391 160.019L133.962 164.948Z",
    fill: "white"
  })), _path621 || (_path621 = /*#__PURE__*/React.createElement("path", {
    d: "M138.875 164.121C138.875 164.121 139.615 165.757 141.245 167.151C141.245 167.151 140.225 174.425 141.794 179.519L145.423 183.789L146.485 178.508C146.485 178.508 144.859 170.056 142.679 166.858C142.679 166.858 143.587 165.141 143.887 163.378L142.585 162.31C142.585 162.31 140.778 163.6 139.692 162.701L138.875 164.121Z",
    fill: "#407BFF"
  })), _path622 || (_path622 = /*#__PURE__*/React.createElement("path", {
    d: "M133.818 158.663C133.818 158.663 137.177 161.525 140.551 161.525C143.926 161.525 144.3 158.004 144.3 158.004L145.723 159.542C145.723 159.542 145.949 162.043 144.562 164.675L141.041 162.3L138.655 165.734C138.655 165.734 134.922 163.936 133.094 160.715L133.818 158.663Z",
    fill: "#407BFF"
  })), _path623 || (_path623 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M133.818 158.663C133.818 158.663 137.177 161.525 140.551 161.525C143.926 161.525 144.3 158.004 144.3 158.004L145.723 159.542C145.723 159.542 145.949 162.043 144.562 164.675L141.041 162.3L138.655 165.734C138.655 165.734 134.922 163.936 133.094 160.715L133.818 158.663Z",
    fill: "white"
  })), _path624 || (_path624 = /*#__PURE__*/React.createElement("path", {
    d: "M134.429 158.004C134.429 158.004 131.674 166.495 145.235 182.69C145.235 182.69 147.67 162.85 143.401 157.381L146.368 158.554L149.455 163.221L147.192 164.675L149.991 165.923C149.991 165.923 149.593 172.352 145.654 184.72C145.654 184.72 136.739 177.827 130.912 168.522L133.624 166.359L129.999 165.787L131.61 159.344L134.429 158.004Z",
    fill: "#263238"
  })), _path625 || (_path625 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M134.429 158.004C134.429 158.004 131.674 166.495 145.235 182.69C145.235 182.69 147.67 162.85 143.401 157.381L146.368 158.554L149.455 163.221L147.192 164.675L149.991 165.923C149.991 165.923 149.593 172.352 145.654 184.72C145.654 184.72 136.739 177.827 130.912 168.522L133.624 166.359L129.999 165.787L131.61 159.344L134.429 158.004Z",
    fill: "black"
  })), _path626 || (_path626 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M122.561 166.864L126.093 186.539L126.506 186.026C128.439 175.939 125.74 166.28 125.74 166.28L124.667 166.852L122.561 166.864Z",
    fill: "black"
  })), _path627 || (_path627 = /*#__PURE__*/React.createElement("path", {
    d: "M145.032 132.062C145.032 132.062 148.87 139.169 145.917 143.491C142.964 147.813 137.946 133.82 137.946 133.82L145.032 132.062Z",
    fill: "#263238"
  })), _path628 || (_path628 = /*#__PURE__*/React.createElement("path", {
    d: "M148.431 147.513C148.413 147.802 148.38 148.088 148.33 148.369C148.164 149.392 147.799 150.341 147.294 151.182C146.764 152.079 146.067 152.844 145.263 153.456C143.8 154.57 141.983 155.16 140.127 154.998C138.898 154.891 137.649 154.459 136.481 153.622C133.108 151.244 132.589 147.897 131.257 142.314C130.955 141.115 130.925 139.864 131.199 138.664C132.132 134.426 136.33 131.756 140.554 132.692C146.487 133.96 148.748 142.217 148.431 147.513Z",
    fill: "#B55B52"
  })), _path629 || (_path629 = /*#__PURE__*/React.createElement("path", {
    d: "M140.114 142.374C140.163 142.836 140.501 143.163 140.806 143.109C141.112 143.055 141.283 142.636 141.205 142.177C141.126 141.718 140.81 141.389 140.512 141.443C140.214 141.496 140.034 141.908 140.114 142.374Z",
    fill: "#263238"
  })), _path630 || (_path630 = /*#__PURE__*/React.createElement("path", {
    d: "M145.316 141.453C145.365 141.915 145.711 142.242 146.009 142.187C146.307 142.134 146.486 141.715 146.407 141.256C146.329 140.797 146.012 140.467 145.714 140.521C145.416 140.575 145.24 141.016 145.316 141.453Z",
    fill: "#263238"
  })), _path631 || (_path631 = /*#__PURE__*/React.createElement("path", {
    d: "M143.704 141.972C144.501 143.283 145.475 144.477 146.599 145.52C146.04 146.091 145.257 146.386 144.461 146.325L143.704 141.972Z",
    fill: "#A02724"
  })), _path632 || (_path632 = /*#__PURE__*/React.createElement("path", {
    d: "M146.851 138.889C146.772 138.953 146.663 138.971 146.568 138.934C145.927 138.658 145.194 138.701 144.589 139.05C144.466 139.137 144.296 139.107 144.21 138.984C144.123 138.86 144.153 138.69 144.276 138.604L144.276 138.603C145.029 138.143 145.958 138.077 146.769 138.425C146.911 138.476 146.983 138.633 146.931 138.774C146.931 138.777 146.93 138.779 146.929 138.78C146.909 138.821 146.883 138.857 146.851 138.889Z",
    fill: "#263238"
  })), _path633 || (_path633 = /*#__PURE__*/React.createElement("path", {
    d: "M138.716 140.476C138.661 140.485 138.605 140.475 138.556 140.45C138.438 140.355 138.419 140.184 138.513 140.066C138.514 140.065 138.516 140.063 138.517 140.061C139.064 139.365 139.916 138.98 140.8 139.027C140.949 139.043 141.057 139.178 141.04 139.328V139.329C141.019 139.477 140.887 139.582 140.738 139.569C140.04 139.552 139.374 139.867 138.943 140.417C138.879 140.469 138.797 140.49 138.716 140.476Z",
    fill: "#263238"
  })), _path634 || (_path634 = /*#__PURE__*/React.createElement("path", {
    d: "M134.154 134.528L135.015 136.927C134.304 137.541 134.023 138.565 134.616 139.452C135.883 141.347 135.435 144.833 134.134 146.478C134.134 146.478 133.881 145.59 133.17 145.975C132.46 146.361 133.73 150.995 135.717 152.893C135.717 152.893 133.021 151.38 130.643 146.751C128.444 142.47 127.44 138.714 127.975 136.745L134.154 134.528Z",
    fill: "#263238"
  })), _path635 || (_path635 = /*#__PURE__*/React.createElement("path", {
    d: "M129.607 147.384C130.46 148.552 131.742 149.334 133.171 149.558C135.065 149.842 135.776 148.088 135.057 146.421C134.403 144.945 132.63 142.967 130.823 143.465C129.016 143.963 128.578 145.938 129.607 147.384Z",
    fill: "#B55B52"
  })), _path636 || (_path636 = /*#__PURE__*/React.createElement("path", {
    d: "M127.834 137.961C127.834 137.961 126.526 134.852 131.082 131.208C135.638 127.563 141.864 129.253 144.803 126.333C147.742 123.414 149.803 132.358 142.729 134.946C135.654 137.533 127.834 137.961 127.834 137.961Z",
    fill: "#263238"
  })), _path637 || (_path637 = /*#__PURE__*/React.createElement("path", {
    d: "M144.355 148.001C143.756 148.679 142.955 150.048 142.955 150.048C142.818 149.998 142.681 149.948 142.547 149.89C140.705 149.163 140.09 148.216 139.969 147.388C139.903 146.935 139.991 146.513 140.106 146.187C140.235 145.808 140.413 145.567 140.413 145.567C141.159 146.536 142.823 147.347 143.731 147.743C144.108 147.912 144.355 148.001 144.355 148.001Z",
    fill: "#263238"
  })), _path638 || (_path638 = /*#__PURE__*/React.createElement("path", {
    d: "M143.73 147.743L143.302 148.336C141.568 147.647 140.441 146.928 140.105 146.188C140.234 145.809 140.412 145.568 140.412 145.568C141.158 146.536 142.823 147.347 143.73 147.743Z",
    fill: "white"
  })), _path639 || (_path639 = /*#__PURE__*/React.createElement("path", {
    d: "M142.547 149.89C140.705 149.163 140.09 148.216 139.969 147.388C140.587 147.66 141.301 148.058 141.854 148.602C142.277 149.017 142.466 149.473 142.547 149.89Z",
    fill: "#A02724"
  })), _path640 || (_path640 = /*#__PURE__*/React.createElement("path", {
    d: "M111.839 188.654C112.712 190.527 114.211 190.704 115.753 189.942C116.973 189.341 118.227 188.138 119.209 186.723C119.913 185.715 120.852 184.198 121.818 182.597C123.886 179.133 126.037 175.287 126.037 175.287C127.335 173.476 128.172 171.343 127.46 168.346C126.212 164.633 124.677 162.499 123.149 162.309C118.989 164.299 110.281 185.3 111.839 188.654Z",
    fill: "#263238"
  })), _path641 || (_path641 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M115.753 189.942C116.973 189.341 118.227 188.138 119.209 186.723C119.913 185.715 120.853 184.198 121.818 182.597C120.632 180.42 119.37 178.7 119.37 178.7L117.27 184.605C117.27 184.605 113.584 185.444 113 187.367C112.78 188.096 114.034 189.129 115.753 189.942Z",
    fill: "black"
  })), _path642 || (_path642 = /*#__PURE__*/React.createElement("path", {
    d: "M115.88 173.066L122.842 199.593C123.004 200.215 123.659 200.652 124.296 200.567L142.761 198.106C143.4 198.021 143.787 197.445 143.624 196.823L136.663 170.297C136.5 169.675 135.846 169.238 135.208 169.323L116.743 171.784C116.104 171.868 115.716 172.444 115.88 173.066Z",
    fill: "#263238"
  })), _path643 || (_path643 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M115.88 173.066L122.842 199.593C123.004 200.214 123.659 200.652 124.296 200.567L141.922 198.218C142.56 198.133 142.948 197.557 142.785 196.935L135.823 170.408C135.66 169.786 135.006 169.349 134.368 169.434L116.743 171.783C116.104 171.868 115.716 172.444 115.88 173.066Z",
    fill: "white"
  })), _path644 || (_path644 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M128.697 183.181C129.614 183.059 130.548 183.684 130.782 184.577C131.016 185.47 130.463 186.294 129.546 186.416C128.628 186.538 127.694 185.913 127.46 185.019C128.378 184.897 128.931 184.074 128.697 183.181Z",
    fill: "white"
  })), _path645 || (_path645 = /*#__PURE__*/React.createElement("path", {
    d: "M114.381 194.907C115.626 195.568 118.43 194.568 119.286 194.229C119.455 194.17 119.549 194.127 119.549 194.127C119.549 194.127 121.082 189.129 117.092 186.427C117.067 186.41 117.033 186.384 116.999 186.376C115.729 185.69 111.789 186.57 111.67 187.901C111.196 193.238 112.898 194.127 114.381 194.907Z",
    fill: "#263238"
  })), _path646 || (_path646 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M116.812 190.637C117.295 192.441 118.354 193.56 119.286 194.228C119.455 194.169 119.549 194.126 119.549 194.126C119.549 194.126 121.082 189.129 117.092 186.426C117.067 186.409 117.033 186.383 116.999 186.375C116.651 186.825 116.109 188.011 116.812 190.637Z",
    fill: "black"
  })), _path647 || (_path647 = /*#__PURE__*/React.createElement("path", {
    d: "M122.564 184.298C122.564 184.298 120.005 184.187 118.828 184.298C117.649 184.41 118.013 188.197 118.013 188.197L117.003 188.744C117.003 188.744 116.183 190.974 117.944 192.093L118.848 191.784C118.848 191.784 119.103 192.678 119.828 193.124C120.554 193.571 124.129 192.566 124.129 192.566L122.564 184.298Z",
    fill: "#B55B52"
  })), _path648 || (_path648 = /*#__PURE__*/React.createElement("path", {
    d: "M189.076 200.569C189.548 200.569 189.93 200.187 189.93 199.715C189.93 199.244 189.548 198.862 189.076 198.862H165.8C165.329 198.862 164.946 199.244 164.946 199.715C164.946 200.187 165.329 200.569 165.8 200.569H189.076Z",
    fill: "#407BFF"
  })), _path649 || (_path649 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M189.076 200.569C189.548 200.569 189.93 200.187 189.93 199.715C189.93 199.244 189.548 198.862 189.076 198.862H165.8C165.329 198.862 164.946 199.244 164.946 199.715C164.946 200.187 165.329 200.569 165.8 200.569H189.076Z",
    fill: "white"
  })), _path650 || (_path650 = /*#__PURE__*/React.createElement("path", {
    d: "M187.101 199.091L190.199 177.044C190.313 176.232 191.063 175.575 191.874 175.575H194.843V200.559H188.363C187.551 200.56 186.986 199.902 187.101 199.091Z",
    fill: "#407BFF"
  })), _path651 || (_path651 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M187.101 199.091L190.199 177.044C190.313 176.232 191.063 175.575 191.874 175.575H194.843V200.559H188.363C187.551 200.56 186.986 199.902 187.101 199.091Z",
    fill: "white"
  })), _path652 || (_path652 = /*#__PURE__*/React.createElement("path", {
    d: "M189.644 200.56H215.962C216.774 200.56 217.523 199.902 217.637 199.091L220.736 177.044C220.85 176.232 220.285 175.575 219.474 175.575H193.155C192.344 175.575 191.594 176.232 191.48 177.044L188.382 199.091C188.268 199.902 188.833 200.56 189.644 200.56Z",
    fill: "#407BFF"
  })), _path653 || (_path653 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M189.644 200.56H215.962C216.774 200.56 217.523 199.902 217.637 199.091L220.736 177.044C220.85 176.232 220.285 175.575 219.474 175.575H193.155C192.344 175.575 191.594 176.232 191.48 177.044L188.382 199.091C188.268 199.902 188.833 200.56 189.644 200.56Z",
    fill: "white"
  })), _path654 || (_path654 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M202.372 189.205C202.196 190.456 203.067 191.47 204.319 191.47C205.571 191.47 206.727 190.456 206.904 189.205C207.08 187.954 206.207 186.94 204.956 186.94C203.705 186.94 202.548 187.954 202.372 189.205Z",
    fill: "white"
  })), _path655 || (_path655 = /*#__PURE__*/React.createElement("path", {
    d: "M108.678 299.638H110.86L113.668 206.013H110.785L108.678 299.638Z",
    fill: "#263238"
  })), _path656 || (_path656 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M108.678 299.638H110.86L113.668 206.013H110.785L108.678 299.638Z",
    fill: "white"
  })), _path657 || (_path657 = /*#__PURE__*/React.createElement("path", {
    d: "M143.863 206.013V299.638H141.553L138.837 210.291H110.97L108.933 299.638H106.646V206.013H143.863Z",
    fill: "#263238"
  })), _path658 || (_path658 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M143.863 206.013V299.638H141.553L138.837 210.291H110.97L108.933 299.638H106.646V206.013H143.863Z",
    fill: "white"
  })), _path659 || (_path659 = /*#__PURE__*/React.createElement("path", {
    d: "M143.863 299.638H146.044L146.747 206.013H143.863V299.638Z",
    fill: "#263238"
  })), _path660 || (_path660 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M143.863 299.638H146.044L146.747 206.013H143.863V299.638Z",
    fill: "white"
  })), _path661 || (_path661 = /*#__PURE__*/React.createElement("path", {
    d: "M227.114 299.638H229.296L232.104 206.013H229.22L227.114 299.638Z",
    fill: "#263238"
  })), _path662 || (_path662 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M227.114 299.638H229.296L232.104 206.013H229.22L227.114 299.638Z",
    fill: "white"
  })), _path663 || (_path663 = /*#__PURE__*/React.createElement("path", {
    d: "M262.298 206.013V299.638H259.988L257.272 210.291H229.406L227.369 299.638H225.082V206.013H262.298Z",
    fill: "#263238"
  })), _path664 || (_path664 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M262.298 206.013V299.638H259.988L257.272 210.291H229.406L227.369 299.638H225.082V206.013H262.298Z",
    fill: "white"
  })), _path665 || (_path665 = /*#__PURE__*/React.createElement("path", {
    d: "M262.298 299.638H264.48L265.182 206.013H262.298V299.638Z",
    fill: "#263238"
  })), _path666 || (_path666 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M262.298 299.638H264.48L265.182 206.013H262.298V299.638Z",
    fill: "white"
  })), _path667 || (_path667 = /*#__PURE__*/React.createElement("path", {
    d: "M145.662 206.013L269 206.013V200.629L145.662 200.629V206.013Z",
    fill: "#263238"
  })), _path668 || (_path668 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M145.662 206.013L269 206.013V200.629L145.662 200.629V206.013Z",
    fill: "white"
  })), _path669 || (_path669 = /*#__PURE__*/React.createElement("path", {
    d: "M102.829 206.013H149.016V200.629H102.829V206.013Z",
    fill: "#263238"
  })), _path670 || (_path670 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M102.829 206.013H149.016V200.629H102.829V206.013Z",
    fill: "white"
  })), _path671 || (_path671 = /*#__PURE__*/React.createElement("path", {
    d: "M245.235 169.696L247.358 165.832L250.21 169.805C250.21 169.805 248.106 173.139 246.435 171.984L245.235 169.696Z",
    fill: "#E4897B"
  })), _path672 || (_path672 = /*#__PURE__*/React.createElement("path", {
    d: "M251.146 163.656L252.438 167.906L250.21 169.805L247.358 165.832L251.146 163.656Z",
    fill: "#E4897B"
  })), _path673 || (_path673 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M248.394 165.236C248.739 166.995 249.329 168.532 250.209 169.805L250.673 169.41L249.209 164.769L248.394 165.236Z",
    fill: "black"
  })), _path674 || (_path674 = /*#__PURE__*/React.createElement("path", {
    d: "M244.697 177.193L245.235 169.696L248.059 170.233V177.782L244.697 177.193Z",
    fill: "#E4897B"
  })), _path675 || (_path675 = /*#__PURE__*/React.createElement("path", {
    d: "M208.412 267.99L212.721 269.675L215.822 263.834L218.639 258.52L213.861 255.657L210.976 262.179L208.412 267.99Z",
    fill: "#E4897B"
  })), _path676 || (_path676 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M210.976 262.179L215.822 263.834L218.639 258.52L213.861 255.657L210.976 262.179Z",
    fill: "black"
  })), _path677 || (_path677 = /*#__PURE__*/React.createElement("path", {
    d: "M211.87 258.994L217.734 262.141C217.734 262.141 239.888 223.185 243.296 223.509C246.704 223.833 279.024 244.432 288.88 236.825C298.736 229.225 289.146 206.315 289.146 206.315C289.146 206.315 268.757 200.487 266.546 204.969C266.116 205.835 265.539 207.571 265.085 209.063C264.65 210.466 264.322 211.651 264.322 211.651C264.322 211.651 264.315 211.65 264.31 211.643C263.689 211.391 243.55 203.134 234.56 207.559C225.426 212.062 211.87 258.994 211.87 258.994Z",
    fill: "#263238"
  })), _path678 || (_path678 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M211.87 258.994L217.734 262.141C217.734 262.141 239.888 223.185 243.296 223.509C246.704 223.833 279.024 244.432 288.88 236.825C298.736 229.225 289.146 206.315 289.146 206.315C289.146 206.315 268.757 200.487 266.546 204.969C266.116 205.835 265.539 207.571 265.085 209.063C264.65 210.466 264.322 211.651 264.322 211.651C264.322 211.651 264.315 211.65 264.31 211.643C263.689 211.391 243.55 203.134 234.56 207.559C225.426 212.062 211.87 258.994 211.87 258.994Z",
    fill: "white"
  })), _path679 || (_path679 = /*#__PURE__*/React.createElement("path", {
    d: "M243.723 290.76L248.319 290.234L248.341 283.746L248.351 277.795L242.792 277.533L243.282 284.536L243.723 290.76Z",
    fill: "#E4897B"
  })), _path680 || (_path680 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M243.299 284.678L248.355 283.873L248.357 277.858L242.796 277.564L243.299 284.678Z",
    fill: "black"
  })), _path681 || (_path681 = /*#__PURE__*/React.createElement("path", {
    d: "M220.601 260.205L212.02 255.908L211.129 259.543L217.625 262.895L220.601 260.205Z",
    fill: "#263238"
  })), _path682 || (_path682 = /*#__PURE__*/React.createElement("path", {
    d: "M273.654 236.887C273.654 236.887 272.241 236.727 250.567 232.711C250.567 232.711 250.078 260.432 249.049 281.093L242.373 281.308C242.373 281.308 232.797 235.447 233.921 228.524C235.046 221.602 243.288 220.664 243.288 220.664C243.288 220.664 257.595 231.779 273.654 236.887Z",
    fill: "#263238"
  })), _path683 || (_path683 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M273.654 236.887C273.654 236.887 272.241 236.727 250.567 232.711C250.567 232.711 250.078 260.432 249.049 281.093L242.373 281.308C242.373 281.308 232.797 235.447 233.921 228.524C235.046 221.602 243.288 220.664 243.288 220.664C243.288 220.664 257.595 231.779 273.654 236.887Z",
    fill: "white"
  })), _path684 || (_path684 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M273.654 236.887C273.654 236.887 272.241 236.727 250.567 232.711C250.567 232.711 250.078 260.432 249.049 281.093L242.373 281.308C242.373 281.308 232.797 235.447 233.921 228.524C235.046 221.602 243.288 220.664 243.288 220.664C243.288 220.664 257.595 231.779 273.654 236.887Z",
    fill: "black"
  })), _path685 || (_path685 = /*#__PURE__*/React.createElement("path", {
    d: "M250.276 279.245L241.169 279.033L242.416 282.785L249.801 282.852L250.276 279.245Z",
    fill: "#263238"
  })), _path686 || (_path686 = /*#__PURE__*/React.createElement("path", {
    d: "M199.844 275.632C200.565 275.413 201.319 275.328 202.07 275.381C202.07 275.381 204.852 274.22 208.212 268.686L211.083 269.064C212.487 269.248 214.376 270.869 214.068 272.189C213.419 274.965 211.182 277.329 209.987 279.908L209.518 279.718L210.99 275.559C211.483 274.145 209.762 275.339 208.853 276.709C207.942 278.078 206.652 279.405 203.583 278.245C200.01 276.873 198.596 276.137 199.844 275.632Z",
    fill: "#263238"
  })), _path687 || (_path687 = /*#__PURE__*/React.createElement("path", {
    d: "M208.944 267.214C208.944 267.214 204.331 274.217 202.07 275.38C202.07 275.38 204.608 277.409 207.992 274.135C212.367 269.901 213.108 270.099 213.108 270.099C213.108 270.099 213.162 269.706 212.98 268.872C212.631 267.263 208.944 267.214 208.944 267.214Z",
    fill: "#E4897B"
  })), _path688 || (_path688 = /*#__PURE__*/React.createElement("path", {
    d: "M236.843 298.912C237.491 298.529 238.204 298.268 238.946 298.141C238.946 298.141 241.373 296.353 243.324 290.18C243.324 290.18 246.196 289.867 246.203 289.866C248.569 289.608 249.975 291.016 249.859 292.728C249.822 294.908 247.711 300.662 247.711 300.662L247.21 300.587L247.654 296.198C247.798 294.707 246.409 296.276 245.85 297.822C245.291 299.368 244.352 300.962 241.096 300.563C237.299 300.079 235.75 299.699 236.843 298.912Z",
    fill: "#263238"
  })), _path689 || (_path689 = /*#__PURE__*/React.createElement("path", {
    d: "M243.687 288.578C243.687 288.578 240.867 296.475 238.946 298.142C238.946 298.142 241.893 299.511 244.404 295.528C247.651 290.377 248.949 290.548 248.949 290.548C248.949 290.548 248.376 290 248.002 289.232C247.281 287.751 243.687 288.578 243.687 288.578Z",
    fill: "#E4897B"
  })), _path690 || (_path690 = /*#__PURE__*/React.createElement("path", {
    d: "M251.29 158.035C251.221 158.035 251.155 158.002 251.115 157.941C250.445 156.917 248.98 156.938 248.964 156.941C248.963 156.941 248.96 156.941 248.96 156.941C248.847 156.941 248.754 156.851 248.752 156.737C248.749 156.622 248.839 156.527 248.954 156.524C249.026 156.518 250.667 156.494 251.465 157.713C251.528 157.809 251.501 157.939 251.404 158.002C251.369 158.024 251.33 158.035 251.29 158.035Z",
    fill: "#263238"
  })), _path691 || (_path691 = /*#__PURE__*/React.createElement("path", {
    d: "M249.654 160.511C249.654 160.511 248.731 161.887 247.792 162.655C247.792 162.655 248.19 163.463 249.196 163.438L249.654 160.511Z",
    fill: "#DE5753"
  })), _path692 || (_path692 = /*#__PURE__*/React.createElement("path", {
    d: "M248.847 158.88C248.788 159.336 248.988 159.739 249.293 159.777C249.597 159.816 249.891 159.477 249.949 159.02C250.008 158.564 249.808 158.161 249.504 158.123C249.2 158.084 248.905 158.423 248.847 158.88Z",
    fill: "#263238"
  })), _path693 || (_path693 = /*#__PURE__*/React.createElement("path", {
    d: "M249.628 158.161L248.684 157.645C248.684 157.645 249.072 158.544 249.628 158.161Z",
    fill: "#263238"
  })), _path694 || (_path694 = /*#__PURE__*/React.createElement("path", {
    d: "M260.713 169.829C260.655 169.875 260.589 169.922 260.525 169.953C259.647 170.514 258.645 171.045 257.526 171.243C254.393 171.806 252.298 171.279 250.986 169.811C250.979 169.811 250.979 169.811 250.979 169.811C249.148 167.614 248.847 163.866 249.339 159.387C249.56 157.333 249.941 155.555 250.576 154.188C250.584 154.175 250.586 154.123 250.594 154.109C250.625 154.054 250.649 153.977 250.68 153.922C251.623 152.016 253.093 150.822 255.368 150.4C256.155 150.255 257.042 150.197 258.038 150.231C266.802 150.568 267.67 165.153 260.713 169.829Z",
    fill: "#E4897B"
  })), _path695 || (_path695 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M260.525 169.953C259.647 170.514 258.651 170.922 257.531 171.121C254.399 171.684 252.309 171.056 250.998 169.566C252.502 169.977 254.542 170.203 256.577 169.381C257.859 168.867 259.238 169.23 260.525 169.953Z",
    fill: "black"
  })), _path696 || (_path696 = /*#__PURE__*/React.createElement("path", {
    d: "M250.575 154.131C250.575 154.131 249.792 160.249 255.484 163.172C255.484 163.172 257.672 169.674 261.347 169.944C266.358 170.312 271.128 163.389 269.745 156.034C267.951 146.497 253.705 145.032 250.575 154.131Z",
    fill: "#263238"
  })), _path697 || (_path697 = /*#__PURE__*/React.createElement("path", {
    d: "M252.622 161.264C252.671 160.306 253.52 158.735 254.998 159.026C256.529 159.327 257.198 163.169 253.367 163.834C252.819 163.928 252.52 163.263 252.622 161.264Z",
    fill: "#E4897B"
  })), _path698 || (_path698 = /*#__PURE__*/React.createElement("path", {
    d: "M261.59 148.124C261.59 148.124 255.803 146.357 252.448 148.554C248.531 151.122 246.958 153.898 251.221 158.535C251.221 158.535 261.216 155.826 264.453 156.661C267.691 157.496 269.984 158.564 269.984 158.564C270.989 152.099 264.927 146.956 261.59 148.124Z",
    fill: "#263238"
  })), _path699 || (_path699 = /*#__PURE__*/React.createElement("path", {
    d: "M256.086 170.646C256.086 170.646 260.389 172.749 259.132 177.36L270.088 172.799C270.088 172.799 264.104 172.423 264.407 168.215C264.407 168.215 258.147 165.811 256.086 170.646Z",
    fill: "#E4897B"
  })), _path700 || (_path700 = /*#__PURE__*/React.createElement("path", {
    d: "M267.881 156.116C267.881 156.116 270.046 149.879 274.96 150.955C279.874 152.031 279.494 157.305 275.981 158.936C272.467 160.566 267.543 159.947 267.881 156.116Z",
    fill: "#263238"
  })), _path701 || (_path701 = /*#__PURE__*/React.createElement("path", {
    d: "M273.683 159.13C273.683 159.13 278.036 159.104 277.5 162.838C277.5 162.838 277.125 161.628 276.144 161.132C276.144 161.132 277.462 162.141 276.15 163.888C276.15 163.888 276.678 162.749 274.878 161.955C273.078 161.159 268.15 161.234 269.067 158.8C269.984 156.365 273.683 159.13 273.683 159.13Z",
    fill: "#263238"
  })), _path702 || (_path702 = /*#__PURE__*/React.createElement("path", {
    d: "M269.336 172.489L266.662 170.565C266.662 170.565 257.869 171.755 257.779 177.361C257.688 182.965 269.336 172.489 269.336 172.489Z",
    fill: "#407BFF"
  })), _path703 || (_path703 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M264.322 211.651L272.701 215.857C272.701 215.857 269.925 211.22 265.085 209.062C264.65 210.466 264.322 211.651 264.322 211.651Z",
    fill: "black"
  })), _path704 || (_path704 = /*#__PURE__*/React.createElement("path", {
    d: "M270.944 172.489C270.944 172.489 264.35 171.221 255.174 177.361C255.174 177.361 252.102 190.799 265.085 209.062L289.704 207.519C289.704 207.519 283.038 180.611 270.944 172.489Z",
    fill: "#263238"
  })), _path705 || (_path705 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M255.918 189.745C256.33 191.472 256.897 193.353 257.653 195.354C259.191 199.451 261.536 204.073 265.083 209.064L289.702 207.518C289.702 207.518 283.037 180.614 270.942 172.488C270.942 172.488 264.353 171.225 255.17 177.358C255.17 177.358 254.088 182.092 255.918 189.745Z",
    fill: "white"
  })), _path706 || (_path706 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M255.918 189.745C256.33 191.472 256.897 193.353 257.653 195.354C257.919 192.425 258.899 188.146 258.899 188.146C258.263 188.215 256.407 189.505 255.918 189.745Z",
    fill: "black"
  })), _path707 || (_path707 = /*#__PURE__*/React.createElement("path", {
    d: "M262.127 182.145C257.771 190.002 253.166 197.716 248.454 205.365C246.392 208.689 241.233 207 241.481 203.148C241.794 198.11 242.19 193.075 242.618 188.041C243.074 183.002 243.574 177.971 244.228 172.951C244.594 170.488 248.166 170.619 248.359 173.089C248.967 183.182 249.098 193.297 249.078 203.402L241.977 201.393C245.071 195.475 248.277 189.62 251.54 183.795C252.649 181.866 253.733 179.922 254.874 178.012C257.783 173.448 264.566 177.319 262.127 182.145Z",
    fill: "#263238"
  })), _path708 || (_path708 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M262.127 182.145C257.771 190.002 253.166 197.716 248.454 205.365C246.392 208.689 241.233 207 241.481 203.148C241.794 198.11 242.19 193.075 242.618 188.041C243.074 183.002 243.574 177.971 244.228 172.951C244.594 170.488 248.166 170.619 248.359 173.089C248.967 183.182 249.098 193.297 249.078 203.402L241.977 201.393C245.071 195.475 248.277 189.62 251.54 183.795C252.649 181.866 253.733 179.922 254.874 178.012C257.783 173.448 264.566 177.319 262.127 182.145Z",
    fill: "white"
  })), _path709 || (_path709 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M249.059 187.954L246.942 191.751L248.857 183.208L249.059 187.954Z",
    fill: "black"
  })), _path710 || (_path710 = /*#__PURE__*/React.createElement("path", {
    d: "M307.157 300.019L286.119 292.272L264.852 300.025C264.118 300.293 263.341 299.749 263.341 298.968C263.341 298.529 263.596 298.131 263.993 297.947L286.12 287.681L308.024 297.946C308.419 298.131 308.671 298.528 308.671 298.964C308.67 299.746 307.891 300.289 307.157 300.019Z",
    fill: "#263238"
  })), _path711 || (_path711 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M307.157 300.019L286.119 292.272L264.852 300.025C264.118 300.293 263.341 299.749 263.341 298.968C263.341 298.529 263.596 298.131 263.993 297.947L286.12 287.681L308.024 297.946C308.419 298.131 308.671 298.528 308.671 298.964C308.67 299.746 307.891 300.289 307.157 300.019Z",
    fill: "white"
  })), _path712 || (_path712 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M281.161 294.079L286.119 292.272L290.849 294.014V289.897L286.119 287.68L281.161 289.981V294.079Z",
    fill: "black"
  })), _path713 || (_path713 = /*#__PURE__*/React.createElement("path", {
    d: "M286.006 300.199C285.042 300.199 284.237 299.467 284.146 298.508L283.552 292.271V240.508H288.459V292.271L287.864 298.508C287.773 299.467 286.969 300.199 286.006 300.199Z",
    fill: "#263238"
  })), _path714 || (_path714 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M286.006 300.199C285.042 300.199 284.237 299.467 284.146 298.508L283.552 292.271V240.508H288.459V292.271L287.864 298.508C287.773 299.467 286.969 300.199 286.006 300.199Z",
    fill: "white"
  })), _path715 || (_path715 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M288.459 240.508H283.552V246.536H288.459V240.508Z",
    fill: "black"
  })), _path716 || (_path716 = /*#__PURE__*/React.createElement("path", {
    d: "M320.135 235.797C314.584 234.381 308.879 233.602 303.158 233.459C297.263 233.311 275.197 233.436 269.957 233.435C263.578 233.432 257.199 234.218 251.01 235.797C247.12 236.789 248.319 242.403 251.833 242.468C252.143 242.474 318.849 242.454 319.095 242.465C322.77 242.633 324.111 236.811 320.135 235.797Z",
    fill: "#407BFF"
  })), _path717 || (_path717 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M320.135 235.797C314.584 234.381 308.879 233.602 303.158 233.459C297.263 233.311 275.197 233.436 269.957 233.435C263.578 233.432 257.199 234.218 251.01 235.797C247.12 236.789 248.319 242.403 251.833 242.468C252.143 242.474 318.849 242.454 319.095 242.465C322.77 242.633 324.111 236.811 320.135 235.797Z",
    fill: "black"
  })), _path718 || (_path718 = /*#__PURE__*/React.createElement("path", {
    d: "M252.816 242.349C264.022 239.491 275.891 239.491 287.096 242.349C291.336 243.43 293.144 236.878 288.903 235.797C276.526 232.64 263.387 232.64 251.01 235.797C246.777 236.877 248.57 243.431 252.816 242.349Z",
    fill: "#407BFF"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M252.816 242.349C264.022 239.491 275.891 239.491 287.096 242.349C291.336 243.43 293.144 236.878 288.903 235.797C276.526 232.64 263.387 232.64 251.01 235.797C246.777 236.877 248.57 243.431 252.816 242.349Z",
    fill: "white"
  }))), _path719 || (_path719 = /*#__PURE__*/React.createElement("path", {
    d: "M302.295 187.18C301.593 187.166 300.888 187.48 300.418 188.261C291.431 203.206 288.238 221.172 291.339 238.312C291.533 239.387 292.269 239.887 293.085 239.942C294.446 240.035 318.664 239.949 319.542 239.947C320.862 239.945 322.314 238.822 322.003 237.108C319.122 221.179 322.295 204.401 330.626 190.546C331.661 188.824 330.135 187.208 328.591 187.179C327.89 187.166 303.838 187.209 302.295 187.18Z",
    fill: "#407BFF"
  })), _path720 || (_path720 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M302.295 187.18C301.593 187.166 300.888 187.48 300.418 188.261C291.431 203.206 288.238 221.172 291.339 238.312C291.533 239.387 292.269 239.887 293.085 239.942C294.446 240.035 318.664 239.949 319.542 239.947C320.862 239.945 322.314 238.822 322.003 237.108C319.122 221.179 322.295 204.401 330.626 190.546C331.661 188.824 330.135 187.208 328.591 187.179C327.89 187.166 303.838 187.209 302.295 187.18Z",
    fill: "black"
  })), _path721 || (_path721 = /*#__PURE__*/React.createElement("path", {
    d: "M295.707 237.109C292.825 221.18 295.998 204.402 304.329 190.547C305.835 188.043 301.921 185.763 300.418 188.261C291.431 203.206 288.238 221.172 291.339 238.312C291.857 241.177 296.223 239.963 295.707 237.109Z",
    fill: "#407BFF"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M295.707 237.109C292.825 221.18 295.998 204.402 304.329 190.547C305.835 188.043 301.921 185.763 300.418 188.261C291.431 203.206 288.238 221.172 291.339 238.312C291.857 241.177 296.223 239.963 295.707 237.109Z",
    fill: "white"
  }))), _path722 || (_path722 = /*#__PURE__*/React.createElement("path", {
    d: "M291.294 129.643C285.059 135.705 275.09 135.565 269.028 129.331C262.966 123.096 263.105 113.127 269.34 107.065C275.575 101.002 285.544 101.142 291.606 107.377C297.668 113.612 297.529 123.581 291.294 129.643Z",
    fill: "#263238"
  })), _path723 || (_path723 = /*#__PURE__*/React.createElement("path", {
    d: "M280.317 118.354L291.294 129.644C285.101 135.666 275.049 135.525 269.028 129.332C263.006 123.139 263.147 113.088 269.34 107.066C272.394 104.097 276.525 102.49 280.783 102.615L280.317 118.354Z",
    fill: "#407BFF"
  })), _path724 || (_path724 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M280.317 118.354L291.294 129.644C289.619 131.272 287.602 132.508 285.391 133.261C283.179 134.014 280.828 134.265 278.506 133.997L280.317 118.354Z",
    fill: "white"
  })), _path725 || (_path725 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M280.317 118.354L293.953 126.227C293.266 127.419 292.424 128.515 291.451 129.489C285.343 135.597 275.29 135.597 269.182 129.489C268.604 128.91 268.071 128.287 267.589 127.626L280.317 118.354Z",
    fill: "white"
  })), _path726 || (_path726 = /*#__PURE__*/React.createElement("path", {
    d: "M274.403 124.268C271.136 121.002 271.136 115.706 274.403 112.439C277.669 109.172 282.965 109.172 286.232 112.439C289.499 115.706 289.499 121.002 286.232 124.268C282.965 127.535 277.669 127.535 274.403 124.268Z",
    fill: "white"
  })), _path727 || (_path727 = /*#__PURE__*/React.createElement("path", {
    d: "M330.338 105.381H310.272C310.115 105.381 309.988 105.254 309.988 105.097C309.988 104.94 310.115 104.813 310.272 104.813H330.338C330.495 104.813 330.622 104.94 330.622 105.097C330.622 105.254 330.495 105.381 330.338 105.381Z",
    fill: "#263238"
  })), _path728 || (_path728 = /*#__PURE__*/React.createElement("path", {
    d: "M326.932 112.01H310.272C310.115 112.01 309.988 111.883 309.988 111.726C309.988 111.569 310.115 111.442 310.272 111.442H326.932C327.088 111.442 327.215 111.569 327.215 111.726C327.215 111.882 327.088 112.01 326.932 112.01Z",
    fill: "#263238"
  })), _path729 || (_path729 = /*#__PURE__*/React.createElement("path", {
    d: "M333.744 118.638H310.272C310.115 118.638 309.988 118.511 309.988 118.354C309.988 118.197 310.115 118.07 310.272 118.07H333.744C333.901 118.07 334.028 118.197 334.028 118.354C334.028 118.51 333.901 118.638 333.744 118.638Z",
    fill: "#263238"
  })), _path730 || (_path730 = /*#__PURE__*/React.createElement("path", {
    d: "M330.338 125.266H310.272C310.115 125.266 309.988 125.139 309.988 124.982C309.988 124.825 310.115 124.698 310.272 124.698H330.338C330.495 124.698 330.622 124.825 330.622 124.982C330.622 125.139 330.495 125.266 330.338 125.266Z",
    fill: "#263238"
  })), _path731 || (_path731 = /*#__PURE__*/React.createElement("path", {
    d: "M331.473 131.894H310.272C310.115 131.894 309.988 131.767 309.988 131.61C309.988 131.453 310.115 131.326 310.272 131.326H331.473C331.63 131.326 331.757 131.453 331.757 131.61C331.757 131.767 331.63 131.894 331.473 131.894Z",
    fill: "#263238"
  })), _path732 || (_path732 = /*#__PURE__*/React.createElement("path", {
    d: "M305.482 103.133H301.439V107.06H305.482V103.133Z",
    fill: "#263238"
  })), _path733 || (_path733 = /*#__PURE__*/React.createElement("path", {
    d: "M305.482 109.762H301.439V113.689H305.482V109.762Z",
    fill: "#263238"
  })), _path734 || (_path734 = /*#__PURE__*/React.createElement("path", {
    d: "M305.482 116.39H301.439V120.317H305.482V116.39Z",
    fill: "#407BFF"
  })), _path735 || (_path735 = /*#__PURE__*/React.createElement("path", {
    d: "M305.482 123.018H301.439V126.945H305.482V123.018Z",
    fill: "#407BFF"
  })), _path736 || (_path736 = /*#__PURE__*/React.createElement("path", {
    d: "M305.482 129.646H301.439V133.573H305.482V129.646Z",
    fill: "#407BFF"
  })), _path737 || (_path737 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M305.482 109.762H301.439V113.689H305.482V109.762Z",
    fill: "white"
  })), _path738 || (_path738 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M305.482 123.018H301.439V126.945H305.482V123.018Z",
    fill: "white"
  })), _path739 || (_path739 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M305.482 129.646H301.439V133.573H305.482V129.646Z",
    fill: "white"
  })), _path740 || (_path740 = /*#__PURE__*/React.createElement("path", {
    d: "M335.502 140.361H263.467C259.586 140.361 256.43 137.205 256.43 133.324V101.27C256.43 97.3901 259.586 94.2334 263.467 94.2334H335.502C339.382 94.2334 342.539 97.3901 342.539 101.27V133.324C342.539 137.205 339.382 140.361 335.502 140.361ZM263.467 95.0672C260.046 95.0672 257.264 97.85 257.264 101.27V133.324C257.264 136.744 260.046 139.526 263.467 139.526H335.502C338.922 139.526 341.704 136.744 341.704 133.324V101.27C341.704 97.8491 338.922 95.0672 335.502 95.0672H263.467Z",
    fill: "#407BFF"
  })), _path741 || (_path741 = /*#__PURE__*/React.createElement("path", {
    d: "M189.611 113.108H187.34V154.661H189.611V113.108Z",
    fill: "#407BFF"
  })), _path742 || (_path742 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M189.611 113.108H187.34V154.661H189.611V113.108Z",
    fill: "black"
  })), _path743 || (_path743 = /*#__PURE__*/React.createElement("path", {
    d: "M193.383 122.336H191.112V154.66H193.383V122.336Z",
    fill: "#263238"
  })), _path744 || (_path744 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M193.383 122.336H191.112V154.66H193.383V122.336Z",
    fill: "white"
  })), _path745 || (_path745 = /*#__PURE__*/React.createElement("path", {
    d: "M182.066 137.715H179.795V154.66H182.066V137.715Z",
    fill: "#407BFF"
  })), _path746 || (_path746 = /*#__PURE__*/React.createElement("path", {
    d: "M185.839 131.563H183.568V154.66H185.839V131.563Z",
    fill: "#407BFF"
  })), _path747 || (_path747 = /*#__PURE__*/React.createElement("path", {
    d: "M197.155 119.26H194.884V154.66H197.155V119.26Z",
    fill: "#263238"
  })), _path748 || (_path748 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M193.383 126.5H191.112V154.66H193.383V126.5Z",
    fill: "white"
  })), _path749 || (_path749 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M197.155 124.771H194.884V154.661H197.155V124.771Z",
    fill: "white"
  })), _path750 || (_path750 = /*#__PURE__*/React.createElement("path", {
    d: "M189.611 116.772H187.34V154.661H189.611V116.772Z",
    fill: "#407BFF"
  })), _path751 || (_path751 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M185.839 139.758H183.568V154.66H185.839V139.758Z",
    fill: "white"
  })), _path752 || (_path752 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M182.066 137.715H179.795V154.66H182.066V137.715Z",
    fill: "white"
  })), _path753 || (_path753 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M182.066 141.569H179.795V154.66H182.066V141.569Z",
    fill: "white"
  })), _path754 || (_path754 = /*#__PURE__*/React.createElement("path", {
    d: "M198.358 154.8H178.593C178.516 154.8 178.453 154.738 178.453 154.661C178.453 154.584 178.516 154.521 178.593 154.521H198.358C198.435 154.521 198.497 154.584 198.497 154.661C198.497 154.738 198.435 154.8 198.358 154.8Z",
    fill: "#263238"
  })), _path755 || (_path755 = /*#__PURE__*/React.createElement("path", {
    d: "M221.212 122.336H218.94V154.66H221.212V122.336Z",
    fill: "#407BFF"
  })), _path756 || (_path756 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M221.212 122.336H218.94V154.66H221.212V122.336Z",
    fill: "black"
  })), _path757 || (_path757 = /*#__PURE__*/React.createElement("path", {
    d: "M224.983 123.228H222.712V154.661H224.983V123.228Z",
    fill: "#263238"
  })), _path758 || (_path758 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M224.983 123.228H222.712V154.661H224.983V123.228Z",
    fill: "white"
  })), _path759 || (_path759 = /*#__PURE__*/React.createElement("path", {
    d: "M213.666 128.584H211.395V154.66H213.666V128.584Z",
    fill: "#407BFF"
  })), _path760 || (_path760 = /*#__PURE__*/React.createElement("path", {
    d: "M217.439 127.835H215.168V154.66H217.439V127.835Z",
    fill: "#407BFF"
  })), _path761 || (_path761 = /*#__PURE__*/React.createElement("path", {
    d: "M228.756 131.176H226.485V154.66H228.756V131.176Z",
    fill: "#263238"
  })), _path762 || (_path762 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M224.983 127.277H222.712V154.66H224.983V127.277Z",
    fill: "white"
  })), _path763 || (_path763 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M228.756 134.831H226.485V154.66H228.756V134.831Z",
    fill: "white"
  })), _path764 || (_path764 = /*#__PURE__*/React.createElement("path", {
    d: "M221.212 125.186H218.94V154.661H221.212V125.186Z",
    fill: "#407BFF"
  })), _path765 || (_path765 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M217.439 132.5H215.168V154.66H217.439V132.5Z",
    fill: "white"
  })), _path766 || (_path766 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M213.666 128.584H211.395V154.66H213.666V128.584Z",
    fill: "white"
  })), _path767 || (_path767 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M213.666 134.516H211.395V154.66H213.666V134.516Z",
    fill: "white"
  })), _path768 || (_path768 = /*#__PURE__*/React.createElement("path", {
    d: "M229.958 154.8H210.193C210.116 154.8 210.053 154.738 210.053 154.661C210.053 154.584 210.116 154.521 210.193 154.521H229.958C230.035 154.521 230.097 154.584 230.097 154.661C230.098 154.738 230.036 154.8 229.958 154.8Z",
    fill: "#263238"
  })), _path769 || (_path769 = /*#__PURE__*/React.createElement("path", {
    d: "M232.954 163.745H176.163C172.282 163.745 169.126 160.588 169.126 156.708V112.955C169.126 109.075 172.282 105.918 176.163 105.918H232.954C236.835 105.918 239.991 109.075 239.991 112.955V156.708C239.991 160.588 236.835 163.745 232.954 163.745ZM176.163 106.753C172.742 106.753 169.96 109.535 169.96 112.955V156.708C169.96 160.128 172.743 162.91 176.163 162.91H232.954C236.375 162.91 239.157 160.128 239.157 156.708V112.955C239.157 109.535 236.374 106.753 232.954 106.753H176.163Z",
    fill: "#407BFF"
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M291.343 77.6955H233.677V45.3643H234.141V77.2314H291.343V77.6955Z",
    fill: "black"
  }))), _path770 || (_path770 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M239.184 72.3296H236.692V76.9995H239.184V72.3296Z",
    fill: "black"
  })), _path771 || (_path771 = /*#__PURE__*/React.createElement("path", {
    d: "M239.184 72.3296H236.692V73.6892H239.184V72.3296Z",
    fill: "#407BFF"
  })), _path772 || (_path772 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M244.274 64.8579H241.781V76.9996H244.274V64.8579Z",
    fill: "black"
  })), _path773 || (_path773 = /*#__PURE__*/React.createElement("path", {
    d: "M244.274 64.8579H241.781V68.3927H244.274V64.8579Z",
    fill: "#407BFF"
  })), _path774 || (_path774 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M249.362 67.6597H246.87V76.9995H249.362V67.6597Z",
    fill: "black"
  })), _path775 || (_path775 = /*#__PURE__*/React.createElement("path", {
    d: "M249.362 67.6597H246.87V70.379H249.362V67.6597Z",
    fill: "#407BFF"
  })), _path776 || (_path776 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M254.452 63.3652H251.959V76.9993H254.452V63.3652Z",
    fill: "black"
  })), _path777 || (_path777 = /*#__PURE__*/React.createElement("path", {
    d: "M254.452 63.3652H251.959V67.3349H254.452V63.3652Z",
    fill: "#407BFF"
  })), _path778 || (_path778 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M259.54 59.4016H257.047V76.9995H259.54V59.4016Z",
    fill: "black"
  })), _path779 || (_path779 = /*#__PURE__*/React.createElement("path", {
    d: "M259.54 59.4016H257.047V64.5256H259.54V59.4016Z",
    fill: "#407BFF"
  })), _path780 || (_path780 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M264.629 56.4036H262.136V76.9995H264.629V56.4036Z",
    fill: "black"
  })), _path781 || (_path781 = /*#__PURE__*/React.createElement("path", {
    d: "M264.629 56.4036H262.136V62.4006H264.629V56.4036Z",
    fill: "#407BFF"
  })), _path782 || (_path782 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M269.718 59.8706H267.225V76.9994H269.718V59.8706Z",
    fill: "black"
  })), _path783 || (_path783 = /*#__PURE__*/React.createElement("path", {
    d: "M269.718 59.8706H267.225V64.8577H269.718V59.8706Z",
    fill: "#407BFF"
  })), _path784 || (_path784 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M274.806 59.123H272.314V76.9997H274.806V59.123Z",
    fill: "black"
  })), _path785 || (_path785 = /*#__PURE__*/React.createElement("path", {
    d: "M274.806 59.123H272.314V64.328H274.806V59.123Z",
    fill: "#407BFF"
  })), _path786 || (_path786 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M279.895 54.5615H277.403V76.9996H279.895V54.5615Z",
    fill: "black"
  })), _path787 || (_path787 = /*#__PURE__*/React.createElement("path", {
    d: "M279.895 54.5615H277.403V61.0944H279.895V54.5615Z",
    fill: "#407BFF"
  })), _path788 || (_path788 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M284.984 49.9644H282.492V76.9997H284.984V49.9644Z",
    fill: "black"
  })), _path789 || (_path789 = /*#__PURE__*/React.createElement("path", {
    d: "M284.984 49.9644H282.492V57.836H284.984V49.9644Z",
    fill: "#407BFF"
  })), _path790 || (_path790 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M290.073 45.9453H287.581V76.9995H290.073V45.9453Z",
    fill: "black"
  })), _path791 || (_path791 = /*#__PURE__*/React.createElement("path", {
    d: "M290.073 45.9453H287.581V54.9871H290.073V45.9453Z",
    fill: "#407BFF"
  })), _path792 || (_path792 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M277.727 40.4824H246.87V41.7653H277.727V40.4824Z",
    fill: "black"
  })), _path793 || (_path793 = /*#__PURE__*/React.createElement("path", {
    d: "M293.038 85.9511H231.56C227.68 85.9511 224.522 82.7944 224.522 78.9141V35.9728C224.522 32.0925 227.679 28.9358 231.559 28.9358H293.038C296.918 28.9358 300.075 32.0925 300.075 35.9728V78.9133C300.075 82.7944 296.917 85.9511 293.038 85.9511ZM231.559 29.7704C228.139 29.7704 225.357 32.5524 225.357 35.9728V78.9133C225.357 82.3337 228.14 85.1156 231.56 85.1156H293.038C296.458 85.1156 299.24 82.3337 299.24 78.9133V35.9728C299.24 32.5524 296.458 29.7704 293.038 29.7704H231.559Z",
    fill: "#407BFF"
  })), _path794 || (_path794 = /*#__PURE__*/React.createElement("path", {
    d: "M123.466 86.5937C123.466 86.5937 134.275 68.9683 137.707 68.6545C141.138 68.3407 145.056 78.6011 147.877 77.6245C150.698 76.648 167.154 47.4977 170.915 48.2814C174.677 49.0651 180.632 64.7733 182.043 64.5204C183.453 64.2667 185.334 61.3755 189.409 69.4032C193.483 77.4309 196.774 86.5937 196.774 86.5937H123.466Z",
    fill: "#407BFF"
  })), _path795 || (_path795 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M123.466 86.5937C123.466 86.5937 134.275 68.9683 137.707 68.6545C141.138 68.3407 145.056 78.6011 147.877 77.6245C150.698 76.648 167.154 47.4977 170.915 48.2814C174.677 49.0651 180.632 64.7733 182.043 64.5204C183.453 64.2667 185.334 61.3755 189.409 69.4032C193.483 77.4309 196.774 86.5937 196.774 86.5937H123.466Z",
    fill: "white"
  })), _path796 || (_path796 = /*#__PURE__*/React.createElement("path", {
    d: "M189.408 86.5936C189.408 86.5936 175.623 56.3424 171.231 54.976C166.839 53.6089 160.884 67.0168 157.906 69.403C154.929 71.7893 150.106 60.6617 148.149 60.5056C146.193 60.3487 137.218 77.9015 134.241 77.7454C131.264 77.5885 130.793 75.3066 127.659 74.0187C124.525 72.7308 116.531 86.5953 116.531 86.5953H189.408V86.5936Z",
    fill: "#407BFF"
  })), _path797 || (_path797 = /*#__PURE__*/React.createElement("path", {
    d: "M191.915 86.5939C191.915 86.5939 185.162 75.2368 182.498 72.5726C179.833 69.9083 176.072 79.2281 173.407 79.5828C170.743 79.9384 160.87 60.975 158.049 59.5645C155.228 58.1539 149.431 74.9229 146.688 75.2368C143.944 75.5498 138.302 65.0865 135.325 64.5198C132.347 63.9531 118.712 86.5939 118.712 86.5939H191.915Z",
    fill: "#263238"
  })), _path798 || (_path798 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M191.915 86.5939C191.915 86.5939 185.162 75.2368 182.498 72.5726C179.833 69.9083 176.072 79.2281 173.407 79.5828C170.743 79.9384 160.87 60.975 158.049 59.5645C155.228 58.1539 149.431 74.9229 146.688 75.2368C143.944 75.5498 138.302 65.0865 135.325 64.5198C132.347 63.9531 118.712 86.5939 118.712 86.5939H191.915Z",
    fill: "white"
  })), _path799 || (_path799 = /*#__PURE__*/React.createElement("path", {
    d: "M197.719 86.3191H114.642V86.8675H197.719V86.3191Z",
    fill: "#263238"
  })), _path800 || (_path800 = /*#__PURE__*/React.createElement("path", {
    d: "M190.033 86.5937C190.033 86.5937 186.728 78.2663 183.906 78.3974C181.085 78.5284 179.989 84.6398 177.324 84.3268C174.66 84.0138 171.524 74.2967 167.529 74.7666C163.533 75.2365 162.75 81.0357 160.242 82.1325C157.735 83.2292 152.818 75.7699 149.661 74.7499C146.505 73.73 142.689 83.6999 139.242 84.3268C135.794 84.9536 134.383 80.2353 132.346 80.6351C130.308 81.0349 124.555 86.5937 124.555 86.5937H190.033Z",
    fill: "#263238"
  })), _path801 || (_path801 = /*#__PURE__*/React.createElement("path", {
    d: "M197.632 95.4853H114.637C110.757 95.4853 107.6 92.3286 107.6 88.4483V46.4017C107.6 42.5214 110.757 39.3647 114.637 39.3647H197.632C201.513 39.3647 204.669 42.5214 204.669 46.4017V88.4475C204.669 92.3286 201.513 95.4853 197.632 95.4853ZM114.637 40.2002C111.216 40.2002 108.435 42.983 108.435 46.4026V88.4492C108.435 91.8696 111.216 94.6515 114.637 94.6515H197.632C201.053 94.6515 203.835 91.8696 203.835 88.4492V46.4034C203.835 42.983 201.053 40.2011 197.632 40.2011L114.637 40.2002Z",
    fill: "#407BFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSlider2Img);
export default __webpack_public_path__ + "static/media/slider2Img.a8201c6c711679467476e950fd7e898e.svg";
export { ForwardRef as ReactComponent };